import AddIcon from "@mui/icons-material/Add";
import UserIcon from "@mui/icons-material/Person";
import DeleteIcon from "@mui/icons-material/Delete";
import { useParams } from 'react-router';
import EditIcon from "@mui/icons-material/Edit";
import RemoveIcon from "@mui/icons-material/Remove";
import moment from "moment-timezone";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import { ToastContainer, toast } from "react-toastify";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import configs from "../Constants";
import Currencies from "../root/currency";
import InputAdornment from '@mui/material/InputAdornment';
import TableBarIcon from "@mui/icons-material/TableBar";
import Chip from "@mui/material/Chip";
//import useScanDetection from 'use-scan-detection';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { onValue, ref } from "firebase/database";
import { db, timeSince } from "./../root/util";
import { printReceipt } from "./util";
import StartOrderPopup from "./sub_comp/StartOrderPopup";
import CustomerSelectionPopup from "./sub_comp/CustomerSelectionPopup";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

import CancelIcon from "@mui/icons-material/Cancel";
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  DialogActions,
  DialogContent,
  Fab,
  Popover,
  Switch,
  CircularProgress,
  Backdrop
} from "@mui/material";
import CategoryIcon from "@mui/icons-material/Category";
import MenuIcon from "@mui/icons-material/Menu";
import BillPrint from "./BillPrint";
import MonitorIcon from "@mui/icons-material/Monitor";
import PaymentOptions from "./sub_comp/PaymentOptions";
import PriceUpdateDialog from "./sub_comp/PriceUpdateDialog";
import { CoPresentOutlined } from "@mui/icons-material";

const Epos = (props) => {
  const { oid } = useParams();

  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";

  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;

  const merchCode = merchantData ? merchantData.merchantCode : "";

  const [orderProcessing, setOrderProcessing] = useState(false);
  const [order, setOrder] = useState(null);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const closeModal = () => setPopUpOpen(false);
  const [totalProducts, setTotalProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [cashPayDialog, setCashPayDialog] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectPro, setSelectPro] = useState();
  const [proOpen, setProOpen] = useState(false);
  const [holdOpen, setHoldOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [filterPro, setFilterPro] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [orderItem, setOrderItem] = useState([]);
  const [variety, setVariety] = useState([]);
  const [cookInst, setCookInst] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDiscountMethod, setSelectedDiscountMethod] = useState("");
  const [price, setPrice] = useState("");
  const [percent, setPercent] = useState(0);
  const [catProducts, setCatProducts] = useState([]);
  const [catId, setCatId] = useState("");
  const [isPayment, setIsPayment] = useState(false);
  const [placeOrder, setPlaceOrder] = useState(true);
  const [procheckbox, setProCheckBox] = useState([]);
  const [addons, setAddons] = useState([]);
  const [addonsGroup, setAddonsGroup] = useState([]);
  const [showWithoutSku, setShowWithoutSku] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [totalAddons, setTotalAddons] = useState([]);
  const [addOnOrders, setAddOnOrders] = useState([]);
  const [cookalignment, setCookAlignment] = useState([]);
  const [showCartIcon, setShowCartIcon] = useState(true);

  const [alignment, setAlignment] = useState("left");
  const [selectedVar, setSelectedVar] = useState({});
  const [addonvalue, setAddonValue] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selAdons, setSelAdons] = useState([]);
  const [invoiceId, setInvoiceId] = useState("");
  const [dialogStep, setDialogStep] = useState(1);
  const [invoiceNo, setInvoiceNo] = useState(new Date().getTime());
  const [showProducts, setShowProducts] = useState(true);
  const [showOrders, setShowOrders] = useState(false);
  const [qRPath, setQRPath] = useState("");
  const [paymentAndBillDialog, setPaymentAndBillDialog] = useState(false);

  const [tableDetail, setTableDetail] = useState(false);
  const [itemCount, setItemCount] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [discValue, setDiscValue] = useState(0);
  const [isleftAlign, setIsLeftAign] = useState(false);
  const [customInstr, setCustomInstr] = useState("");
  const [noteText, setNoteText] = useState("");
  const [showNoteInput, setShowNoteInput] = useState(false);

  const [containedIndex, setContainedIndex] = useState(3);
  const [paymentIndex, setPaymentIndex] = useState(1);
  const [selectedWindex, setSelectedWindex] = useState(null);

  const [payModeIndx, setPayModeIndx] = useState(parseInt(merchantData?.defaultPaymentMethodPos) || 0);
  const [payModeSelectDialog, setPayModeSelectDialog] = useState(false);

  const navigate = useNavigate();
  const [selectedCat, setSelectedCat] = useState("");

  const [tableData, setTableData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [selectedTable, setSelectedTable] = useState("");
  const [editPriceDialog, setEditPriceDialog] = useState(null);
  const [ordId, setOrdId] = useState("");

  const [weightDialogOpen, setWeightDialogOpen] = useState(false);
  const [skuErrorDialog, setSkuErrorDialog] = useState(false);
  const [weightErrorDialog, setWeightErrorDialog] = useState(false);
  const [weightInputIndex, setWeightInputIndex] = useState(null);
  const [tempWeight, setTempWeight] = useState(""); // Temporary input value
  // const [barcodeScan, setBarCodeScan] = useState("");
  const [kitchens, setKitchens] = useState([]);
  const [allOffers, setAllOffers] = useState([]);
  const [isNewOrder, setNewOrder] = useState(oid ? false : merchantData?.bizVertical?.toLowerCase() === 'retail' ? false : true);
  const [isCustomerPopupOpen, setIsCustomerPopupOpen] = useState(false);
  let isPortrait = window.innerWidth < window.innerHeight;
  const [isCatDialogOpen, setIsCatDialogOpen] = useState(false);
  const [catAnchorEl, setCatAnchorEl] = useState(null);
  const [cashOut, setCashOut] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [isTerminalPopupOpen, setIsTerminalPopupOpen] = useState(false);

  const orderRef = useRef(order);
  const totalProductsRef = useRef(totalProducts);
  const selectedWindexRef = useRef(selectedWindex);
  const handleProductRef = useRef(null);
  const cartRef = useRef(null);
  let finalOrderItems = [];
  const prodsBySku = totalProducts.reduce((acc, p) => {
    acc[p.SKU_id || p._id] = p
    return acc;
  }, {});
  useEffect(() => {
    orderRef.current = order;
  }, [order]);

  useEffect(() => {
    totalProductsRef.current = prodsBySku;
    console.log("--", totalProductsRef.current);
  }, [orderItem]);

  useEffect(() => {
    totalProductsRef.current = prodsBySku;
    console.log("->>-", totalProductsRef.current);
  }, [totalProducts]);

  useEffect(() => {
    selectedWindexRef.current = selectedWindex;
  }, [selectedWindex]);

  useEffect(() => {
    handleProductRef.current = handleProduct;
  });

  const openWeightDialog = (indx) => {
    setWeightInputIndex(indx);
    setTempWeight(order.orderItems[indx].weight || "");
    setWeightDialogOpen(true);
  };

  const closeWeightDialog = () => {
    setWeightDialogOpen(false);
    setWeightInputIndex(null);
    setTempWeight("");
  };

  const saveWeight = () => {
    if (weightInputIndex === null) return;
    const items = [...order.orderItems];
    items[weightInputIndex].weight = parseFloat(tempWeight) || 0;
    items[weightInputIndex].inputMode = "weight"; // Switch inputMode to weight
    setOrderItem(items);
    setWeightDialogOpen(false);
  };

  const { formatMessage: t, locale, setLocale } = useIntl();
  let authApi = configs.authapi;
  let staticSer = configs.staticSer;


  const handleTableChange = (tabNum) => {
    setSelectedTable(tabNum);
    let tabId = tableData.filter((tab) => tab.number === tabNum);
    localStorage.setItem("tableId", tabId[0].id);
    setTableDetail(false);
  };

  const handleDiscountMethodSelect = (event) => {
    setSelectedDiscountMethod(event.target.value);
  };


  const handleClose = () => {
    setAnchorEl(false);
  };

  let cmsUrl = `${configs.cmsUrl}?token=${localStorage.getItem("token")}`;
  const handledisc = () => {
    setIsDropdownOpen(true);
  };

  //bar code scanner
  // useScanDetection({
  //   onComplete: (code) => {
  //     console.log('Node coe foaund');
  //     console.log(code);
  //     //toast.success(code);
  //     // if (isTerminalPopupOpen) {
  //     //   console.log('Scan blocked: Terminal popup is open');
  //     //   return;
  //     // }

  //     if (code.length) {
  //       let prod = totalProducts.find(p => p.SKU_id == code);
  //       console.log(prod);
  //       if (prod) {
  //         handleProduct(prod);
  //       }
  //       // setBarCodeScan(code);
  //       return true;
  //     }
  //   }
  // }
  // );

  // console.log(barcodeScan);

  const handleAlignment = (event, newAlignment) => {
    let newVar = {};
    newVar[newAlignment] = variety[newAlignment];
    setSelectedVar(newVar);
  };

  const handleCookAlignment = (newAlignment) => {
    let updateCookInst = [...cookalignment];
    if (cookalignment.indexOf(newAlignment) == -1) {
      updateCookInst.push(newAlignment);
    } else {
      updateCookInst.splice(updateCookInst.indexOf(newAlignment), 1);
    }
    setCookAlignment(updateCookInst);
  };

  let cat = categories;

  const adAddons = (e, itemId, index, pi) => {
    let AoIndx = -1;
    let newAdOns = [...selAdons];
    newAdOns.map((ao, i) => {
      return ao.id == itemId ? (AoIndx = i) : false;
    });
    // console.log(AoIndx);
    if (AoIndx != -1) {
      newAdOns.splice(AoIndx, 1);
    } else {
      newAdOns.push(pi);
    }
    setSelAdons(newAdOns);
  };

  let baseURL = configs.baseURL;
  // let baseURL = "https://inventory-service-gthb.onrender.com";
  const removeAddons = (itemId) => {
    // console.log(itemId);
  };

  let userToken = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "";

  // let userToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NTZmMmE2ODc0YTRkNjIzYmJlM2Q1ODAiLCJyb2xlIjoiQWRtaW4iLCJpYXQiOjE3NDQyNjUxNTAsImV4cCI6MTc0NDg2OTk1MH0.NmI9JEM2gChfmIL9R8eR3XVpjLom4PUdKx0NTD_0bCE"

  const handleOrder = () => {
    //document.getElementById('bar').style.display='none';
    setShowOrders(true);
    setShowProducts(false);
    setShowCartIcon(false);
  };
  console.log(userData);

  if (merchantData) {
    merchantData.taxPerc = (userData && userData.taxPerc) || merchantData?.takeAwayTax;
  }

  if ((containedIndex == 1 || containedIndex == 3) && merchantData?.dineinTax) {
    merchantData.taxPerc = merchantData.dineinTax;
  }

  const updateCustomerDisplay = () => {
    try {
      if (window.OrdersUpdateInterface && merchantData.show_customer_display) {
        //if (true) {
        let orderCustomerView = Object.assign({}, order);
        console.log(orderCustomerView);
        orderCustomerView.orderItems = orderCustomerView.orderItems.map((item) => {
          let nameWithOffer = item.name;
          if (item.appliedOfferDescription) {
            nameWithOffer = item.name + " (" + item.appliedOfferDescription + ")";

          }
          return {
            ...item,
            name: nameWithOffer,
            itemSubtotal: item.totalPrice

          };
        });
        console.log(orderCustomerView);
        window.OrdersUpdateInterface.update(JSON.stringify(orderCustomerView))
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  // const merchCode = merchantData ? merchantData.merchantCode : "";
  useEffect(() => {
    setIsLeftAign(merchantData?.isLeftAlign);
  }, [merchantData]);



  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData?.currency
  );
  //console.log(currency)
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  // console.log(SelectCurrency);

  const userId = userData && userData.isIAM ? userData.parentUser : userData.sub;
  const getCatByUser = `${baseURL}/api/categories?merchantCode=${merchCode}`;
  const getProductByUser = `${baseURL}/api/products?merchantCode=${merchCode}`;
  const getLatestInvoiceNumber =
    configs.payServer + `/api/invoice/latest/${userId}`;

  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });
  const selectedCurrency = (
    <span dangerouslySetInnerHTML={{ __html: SelectCurrency }} />
  );
  // console.log(selectedCurrency);
  const fetchKitchens = async () => {
    if (merchantData?.bizVertical?.toLowerCase() === 'retail') return;

    try {
      const res = await axios.get(
        `${baseURL}/api/kitchens?merchantCode=${merchCode}`
      );
      console.log("getting", res.data);
      setKitchens(res.data);
    } catch (err) {
      console.error("Error fetching kitchens:", err);
    }
  };

  const fetchOffers = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/offers?merchantCode=${merchCode}`
      );
      console.log("offers fetched", res.data);
      setAllOffers(res.data);
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };

  useEffect(() => {
    if (merchCode) {
      merchantData?.bizVertical?.toLowerCase() !== 'retail' && fetchKitchens();
      fetchOffers();
      setContainedIndex(getContainIndx(merchantData?.defaultOrderType));
      if (merchantData.defaultPaymentMethodPos !== undefined) {
        setPayModeIndx(parseInt(merchantData.defaultPaymentMethodPos));
      }
    }
  }, [merchCode]);


  useEffect(() => {
    if (merchCode) {
      axios.get(getCatByUser).then((response) => {
        //console.log(response.data);
        setCategories(response.data);
      });
    }
  }, [merchCode]);

  const listProductAndCat = (categories) => {
    axios.get(getProductByUser).then((response) => {
      let orderableCats = categories
        .filter((ct) => ct.isOrderableAlone || !ct.isAddOn)
        .map((ct) => ct.id);

      const allProducts = response.data;

      const orderableItems = allProducts.filter(
        (itm) => itm.inStock && orderableCats.includes(itm.category)
      );

      setTotalProducts(allProducts);

      const defaultCategory = categories.find(
        (ct) => ct.isOrderableAlone || !ct.isAddOn
      );
      if (defaultCategory) {
        if (merchantData?.eposCategoryDisplay !== 'cards') {
          const defaultCatId = defaultCategory._id || defaultCategory.id;
          setSelectedCat(defaultCatId);
          const filteredProducts = orderableItems.filter(
            (p) => p.category === defaultCatId
          );
          setProducts(filteredProducts);
        } else {
          setSelectedCat("");
          setProducts(orderableItems);
        }
      }

      let addons = categories.filter((c) => c.isAddOn).map((c) => c.id);
      setAddonsGroup(
        allProducts.filter((pro) => addons.includes(pro.category))
      );
    });
  };

  useEffect(() => {
    const handleNativeMessage = (event) => {
      if (isTerminalPopupOpen) {
        console.log('Native message ignored: Terminal popup is open');
        return;
      }

      if (event?.detail?.skuCode) {
        let code = event?.detail?.skuCode || "";
        if (code.length) {
          // let prod = totalProductsRef.current[code];
          //console.log(prod);
          if (totalProductsRef.current.hasOwnProperty(code)) {
            handleProductRef.current(totalProductsRef.current[code]);
          } else {
            playErrorSound();
            setSkuErrorDialog(true);
          }
          // setBarCodeScan(code);
          return true;
        }
      }


      if (event?.detail?.weight && event?.detail?.weight !== "undefined") {
        let rawWeightStr = String(event.detail.weight).trim();
        try {
          let read = localStorage.getItem("reading");
          if (read && event?.detail?.weight.toString() == read.toString()) {
            localStorage.removeItem("reading");
            playErrorSound();
            setWeightErrorDialog(true);
            return;
          } else {
            localStorage.setItem("reading", event?.detail?.weight)
          }

        } catch (e) { }
        // Remove any non-numeric characters except '.'
        rawWeightStr = rawWeightStr.replace(/[^0-9.]/g, '');
        let parsedWeight = parseFloat(rawWeightStr);
        if (isNaN(parsedWeight)) parsedWeight = 0;

        // If the weight has a decimal point and is less than 100, the scale is likely sending kg (e.g. "0.270" or "0000.270kg")
        // Since the POS works in grams, we convert it.
        if (String(event.detail.weight).includes('.') && parsedWeight > 0 && parsedWeight < 100) {
          parsedWeight = Math.round(parsedWeight * 1000);
        }

        let newOrderItems = [
          ...orderRef.current.orderItems,
        ];
        if (selectedWindexRef.current !== null && selectedWindexRef.current !== undefined && newOrderItems[selectedWindexRef.current]) {
          newOrderItems[selectedWindexRef.current].weight = parsedWeight;
          newOrderItems[selectedWindexRef.current].quantity = parsedWeight; // Save weight into quantity

          if (window.OrdersUpdateInterface) {
            window.OrdersUpdateInterface.update(JSON.stringify(updateOrderDetails(newOrderItems)));
          }
          setOrderItem(newOrderItems);
        }
      }
    };

    // Add event listener
    window.addEventListener('nativeOsMessage', handleNativeMessage);

    // Cleanup function to remove the listener when the component unmounts
    return () => {
      window.removeEventListener('nativeOsMessage', handleNativeMessage);
    };
  }, []); // Empty array ensures the listener is set up once

  useEffect(() => {
    if (cartRef.current) {
      cartRef.current.scrollTop = cartRef.current.scrollHeight;
    }
  }, [orderItem]);

  useEffect(() => {
    if (categories.length) {
      const defaultCategory = categories.find(
        (ct) => ct.isOrderableAlone || !ct.isAddOn
      );
      if (defaultCategory) {
        if (merchantData?.eposCategoryDisplay !== 'cards') {
          const catId = defaultCategory._id || defaultCategory.id;
          setSelectedCat(catId);

          // Filter and show products from the selected category
          const prodAsPerCat = totalProducts.filter((p) => p.category === catId);
          setProducts(prodAsPerCat);
        } else {
          setSelectedCat("");
        }
      }
    }

    listProductAndCat(categories);
  }, [categories]);

  const handleTableDetail = () => {
    setTableDetail(true);
  };


  const cancelTable = () => {
    setTableDetail(false);
  };

  const nextHandler = () => {
    selectedProduct.sub_pro = {};
    // Set price if variety price available
    let varName = Object.keys(selectedVar);
    // Parse and assign price from varietyPrices
    if (varName.length) {
      const varietyPrices = JSON.parse(selectedProduct.varietyPrices || "{}");
      selectedProduct.price =
        parseFloat(varietyPrices[varName[0]]) || selectedProduct.price;

      // Parse and assign container_price from container_varietyPrice
      const containerPrices = JSON.parse(
        selectedProduct.container_varietyPrice || "{}"
      );
      selectedProduct.container_price =
        parseFloat(containerPrices[varName[0]]) ||
        selectedProduct.container_price;
    }

    selectedProduct.sub_pro.addons = [...selAdons];
    selectedProduct.sub_pro.variety = selectedVar;
    selectedProduct.sub_pro.cookInstructions = cookalignment;

    if (customInstr) {
      selectedProduct.sub_pro.cookInstructions.push(customInstr);
    }

    setIsOpen(false);
    setAddons([]);
    setSelAdons([]);
    setSelectedProduct();
    if (editingIndex !== null) {
      const newItems = [...order.orderItems];
      newItems[editingIndex] = selectedProduct;
      setOrderItem(newItems);
      selectedWindexRef.current = editingIndex;
      setSelectedWindex(editingIndex);
      setEditingIndex(null);
    } else {
      // Add product to the order with addons and variety
      addPrductToOrder(selectedProduct);

      // Add addons to the order
      addOnOrders.map((a) => addPrductToOrder(a));
    }
  };

  const addPrductToOrder = (p) => {

    let oItems = orderRef?.current?.orderItems || orderItem;
    // console.log(oItems);
    const orderItems = Array.isArray(oItems) ? [...oItems] : [];
    // console.log(oItems);
    let matchedIndex = -1;

    // If p.sub_pro is defined, do deep comparison
    if (p.sub_pro) {
      const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

      for (let i = 0; i < oItems.length; i++) {
        const item = oItems[i];

        if (item.id !== p.id) continue;

        // Case 1: Both have sub_pro
        if (item.sub_pro) {
          const sameVariety = isEqual(p.sub_pro.variety || {}, item.sub_pro.variety || {});
          const sameAddons = isEqual(p.sub_pro.addons || [], item.sub_pro.addons || []);
          if (sameVariety && sameAddons) {
            matchedIndex = i;
            break;
          }
        }
      }
    } else {
      // If p.sub_pro is undefined, match only by id
      for (let i = 0; i < oItems.length; i++) {
        // console.log(oItems[i]);
        if (oItems[i].id === p.id) {
          matchedIndex = i;
          break;
        }
      }
    }

    let activeIndex = -1;
    if (matchedIndex !== -1 && !p.is_weight_type) {
      if (!(orderItems[matchedIndex].is_weight_type)) {
        orderItems[matchedIndex].quantity = (orderItems[matchedIndex].quantity || 1) + 1;
      }
      activeIndex = matchedIndex;
    } else {
      const isWeightItem = p.is_weight_type;
      orderItems.push({
        ...p,
        quantity: isWeightItem ? 0 : 1,
        weight: 0,
        inputMode: isWeightItem ? "weight" : "count",
        select_type: isWeightItem ? "weight" : "variety"
      });
      activeIndex = orderItems.length - 1;
    }

    // setOrderItem(orderItems);
    const updatedOrder = updateOrderDetails(orderItems);
    selectedWindexRef.current = activeIndex;
    setSelectedWindex(activeIndex);
    //console.log(updatedOrder);
    if (p.weight_price && p.is_weight_type && window.WeightRequestInterface) {
      window.WeightRequestInterface.sendCommand();
    } else {
      setTimeout(function () {
        if (window.OrdersUpdateInterface) {
          //if (true) {
          //console.log('--------************', updatedOrder);
          window.OrdersUpdateInterface.update(JSON.stringify(updatedOrder));
        }
      }
        , 500);
    }

  };

  const handleProduct = (p) => {
    // console.log(p);
    setCustomInstr("");
    if (p.isPriceVariety || p.add_ons || p.cookInstructions) {
      // console.log("if running");
      setIsOpen(true);
      setSelectedVar({});
      setCookAlignment([]);
      setVariety(p && p.varietyPrices ? JSON.parse(p.varietyPrices) : {});
      setCookInst(p && p.cookInstructions ? p.cookInstructions.split(",") : []);

      const paddon = p.add_ons.split(",").filter((a) => a.length);
      let addName = addonsGroup.filter((li) => paddon.indexOf(li.id) != -1);
      setAddons(addName);
      setProCheckBox([]);
      setSelAdons([]);

      setSelectedProduct(p);
    } else {
      // console.log("else running");
      addPrductToOrder(p);
    }
  };

  const handleEditProduct = (item, indx) => {
    setEditingIndex(indx);
    setCustomInstr("");

    // Find the original product object from totalProducts to get varieties/addons info
    const p = totalProducts.find(
      (prod) => prod.id === item.id || prod._id === item.id
    );
    if (!p) return;

    const subPro =
      typeof item.sub_pro === "string" ? JSON.parse(item.sub_pro) : item.sub_pro;

    setIsOpen(true);
    setSelectedVar(subPro.variety || {});
    setCookAlignment(subPro.cookInstructions || []);
    setVariety(p.varietyPrices ? JSON.parse(p.varietyPrices) : {});
    setCookInst(p.cookInstructions ? p.cookInstructions.split(",") : []);

    const paddon = p.add_ons ? p.add_ons.split(",").filter((a) => a.length) : [];
    let addName = addonsGroup.filter((li) => paddon.indexOf(li.id) != -1);
    setAddons(addName);
    setProCheckBox([]);
    setSelAdons(subPro.addons || []);

    setSelectedProduct({ ...p, sub_pro: subPro, quantity: item.quantity });
  };

  const showVarietyBtn = (variety) => {
    if (!Object.keys(variety).length) return;
    let selectedVarArr = Object.keys(selectedVar);
    let selVarArr = selectedVarArr.length
      ? selectedVarArr
      : handleAlignment("", Object.keys(variety)[0]);
    // console.log(selVarArr);
    return (
      <ToggleButtonGroup
        value={selVarArr}
        onChange={handleAlignment}
        exclusive
        aria-label="text alignment"
        style={{ backgroundColor: "white", overflow: "auto" }}
      >
        {Object.keys(variety).map((key, index) => (
          <ToggleButton
            style={{ display: "inline-block", padding: "none !important" }}
            value={key}
            aria-label="left aligned"
          >
            <div style={{ display: "block", width: "100%" }}>{key}</div>
            <div
              style={{ color: "#000", fontWeight: "bold", fontSize: "1.2em" }}
            >
              {selectedCurrency}
              {+variety[key]}
            </div>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  };
  const showinstructionBtn = () => {
    return (
      <div>
        <ToggleButtonGroup
          value={cookalignment}
          exclusive
          aria-label="text alignment"
          style={{ backgroundColor: "white" }}
        >
          {cookInst.map((key, index) => (
            <ToggleButton
              style={{ display: "inline-block", padding: "none !important" }}
              value={key}
              onClick={() => handleCookAlignment(key)}
              aria-label="left aligned"
            >
              <div style={{ display: "block", width: "100%" }}>{key}</div>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <div style={{ padding: "10px 50px" }}>
          <TextField
            className="notes"
            type="text"
            variant="outlined"
            min={1}
            style={{ fontSize: "1.2em" }}
            value={customInstr}
            onChange={(e) => setCustomInstr(e.target.value)}
            fullWidth={true}
            placeholder={t({ id: "add_custom_notes" })}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (oid) {
      axios
        .get(`${baseURL}/api/orders/${oid}?merchantCode=${merchCode}`)
        .then((res) => {
          //console.log(res.data);
          let odr = res.data;
          if (odr.orderItems) {
            setOrder(odr);
            setOrderItem(odr.orderItems);
            let containdInx = getContainIndx(odr.orderType);
            setContainedIndex(containdInx);
            containdInx == 1 && setSelectedTable(odr.number);
            updateOrderDetails(null, odr);
          }
        });
    }

  }, [oid]);

  useEffect(() => {
    updateOrderDetails();
  }, [orderItem, containedIndex, discValue, percent, allOffers, selectedDiscountMethod]);

  let productItems = isSearch ? filterPro : products;
  // console.log("productsItem", productItems);

  const handleAdd = (indx) => {
    console.log('----');
    const newItems = [...order.orderItems];
    newItems[indx].quantity += 1;
    newItems[indx].itemSubtotal = newItems[indx].totalPrice;
    setOrderItem(newItems);
    updateOrderDetails(newItems);
    if (window.OrdersUpdateInterface) {
      //  if (true) {
      window.OrdersUpdateInterface.update(JSON.stringify(updateOrderDetails(newItems)));
    }
  };
  // // console.log(order);
  // const readWeight = async (item) => {
  //   try {
  //      alert('reading weight');
  //     console.log('reading weight');
  //     const port = await navigator.serial.requestPort();
  //     await port.open({ baudRate: 9600 });

  //     const decoder = new TextDecoderStream();
  //     port.readable.pipeTo(decoder.writable);
  //     const reader = decoder.readable.getReader();

  //     while (true) {
  //       const { value, done } = await reader.read();
  //       if (done) break;

  //       alert("Raw:", value);

  //       const match = value.match(/([\d.]+)/);
  //       if (match) alert("Weight:", parseFloat(match[1]));
  //     }
  //   } catch (err) {
  //     alert(err);
  //     if (err.name === 'NotFoundError') {
  //       console.log("User canceled the port selection.");
  //     } else {
  //       console.error("Serial port error:", err);
  //     }
  //   }
  // }
  const handleRemove = (indx) => {
    const newOrderItems = [...order.orderItems];
    newOrderItems[indx].quantity -= 1;
    newOrderItems[indx].itemSubtotal = newOrderItems[indx].totalPrice;
    const filteredItems = newOrderItems.filter((x) => x.quantity > 0);

    if (filteredItems.length === 0) {
      const updatedOrder = { ...order, orderItems: [] };
      setOrder(updatedOrder);
      setOrderItem([]);
      setItemCount(0);
      updateOrderDetails([]);
    } else {
      setOrderItem(filteredItems);
      setItemCount(filteredItems.length);
      updateOrderDetails(filteredItems);
    }
    setPrice("");
    setPercent(0);
    if (window.OrdersUpdateInterface) {
      //if (true) {
      window.OrdersUpdateInterface.update(JSON.stringify(updateOrderDetails(filteredItems)));
    }
  };

  const deleteItem = (indx) => {
    const newItems = [...order.orderItems];
    newItems.splice(indx, 1);

    if (newItems.length === 0) {
      setOrder({ ...order, orderItems: [] });
      setOrderItem([]);
      setItemCount(0);
      updateOrderDetails([]);
    } else {
      setOrderItem(newItems);
      updateOrderDetails(newItems);
    }
    setPrice("");
    setPercent(0);
    if (window.OrdersUpdateInterface) {
      //if (true) {
      window.OrdersUpdateInterface.update(JSON.stringify(updateOrderDetails(newItems)));
    }
  };

  const handleSearch = (e) => {
    let val = e.target.value;
    setSearchText(val);
  };

  const toggleWithoutSku = (e) => {
    const checked = e.target.checked;
    setShowWithoutSku(checked);
  };

  const applyFilter = () => {
    let fltData = totalProducts.filter(
      (pro) =>
        pro.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 &&
        pro.inStock === true &&
        (showWithoutSku ? !pro.SKU_id : true) &&
        (!searchText.length && selectedCat ? pro.category === selectedCat : true)
    );
    setFilterPro(fltData);
    setIsSearch(searchText !== "" || showWithoutSku);
  };

  useEffect(() => {

    applyFilter();
  }, [showWithoutSku, selectedCat, totalProducts]);

  const updateOrderDetails = (newOrderItems, odr) => {
    const currentItems = newOrderItems || orderItem;
    if (newOrderItems) {
      setOrderItem(newOrderItems);
    }

    // Calculate total quantities for group offers
    const groupQuantities = {};
    allOffers.forEach(o => {
      if (o.productIds && o.productIds.length > 0) {
        const totalQty = currentItems.reduce((acc, item) => {
          const itemId = item.id || item._id;
          if (o.productIds.some(pid => pid.toString() === itemId.toString())) {
            return acc + (item.quantity || 1);
          }
          return acc;
        }, 0);
        groupQuantities[o.id] = totalQty;
        // console.log(`Group Offer ${o.id}: Total Qty = ${totalQty}, Product IDs:`, o.productIds);
      }
    });

    let orderItems = currentItems.map((item) => {
      let x = { ...item }; // Clone item to avoid direct mutation
      if (!x.sub_pro) {
        x.sub_pro = { addons: [], variety: {}, cookInstructions: [] };
      }
      if (!x.quantity && !x.is_weight_type && x.inputMode !== 'weight') {
        x.quantity = 1;
      }
      let addonsPrice =
        x.sub_pro && x.sub_pro.addons
          ? x.sub_pro.addons.reduce((acc, val) => acc + val.price, 0)
          : 0;

      // Find offer for the product
      let offer = allOffers.find(o =>
        (o.productId && x.id && o.productId.toString() === x.id.toString()) ||
        (o.productId && x._id && o.productId.toString() === x._id.toString())
      );

      // If no single product offer, check for group offer
      if (!offer) {
        offer = allOffers.find(o =>
          o.productIds && (
            (x.id && o.productIds.includes(x.id)) ||
            (x._id && o.productIds.includes(x._id))
          )
        );
      }
      let currentPrice = x.price;
      let discountAmountPerItem = 0;
      x.appliedOfferDescription = null; // Reset by default

      if (offer) {
        if (offer.overridePrice !== undefined && offer.overridePrice !== null && offer.overridePrice !== 0) {
          currentPrice = parseFloat(offer.overridePrice);
        }

        const X = parseInt(offer.X) || 0;
        const Y = parseFloat(offer.Y) || 0; // This is Y for FREE or % for discount types or flat price

        if (offer.type === "Flat % OFF") {
          discountAmountPerItem = (currentPrice * Y) / 100;
          x.appliedOfferDescription = `${Y}% OFF`;
        } else if (offer.type === "BUY X GET % OFF") {
          // Use group total quantity if it's a group offer, otherwise item quantity
          const qtyToCheck = offer.productIds ? groupQuantities[offer.id] : x.quantity;

          if (qtyToCheck >= X) {
            // Apply discount to all items of this product
            discountAmountPerItem = (currentPrice * Y) / 100;
            x.appliedOfferDescription = `BUY ${X} GET ${Y}% OFF`;
          }
        } else if (offer.type === "BUY X GET Y FREE") {
          const qtyToCheck = offer.productIds ? groupQuantities[offer.id] : x.quantity;
          if (qtyToCheck >= (X + Y)) {
            const groupsOfOffer = Math.floor(qtyToCheck / (X + Y));
            const freeItemsCount = groupsOfOffer * Y;

            // Distribute the value of the free items proportionally across all items in the group
            // This applies a percentage discount equivalent to (FreeCount / TotalCount)
            discountAmountPerItem = (currentPrice * freeItemsCount) / qtyToCheck;

            x.appliedOfferDescription = `BUY ${X} GET ${Y} FREE`;
          }
        } else if (offer.type === "BUY X FOR FLAT Y") {
          const qtyToCheck = offer.productIds ? groupQuantities[offer.id] : x.quantity;
          if (qtyToCheck >= X) {
            const groupsOfOffer = Math.floor(qtyToCheck / X);
            const countInGroups = groupsOfOffer * X;
            const totalDiscountForGroups = (currentPrice * countInGroups) - (groupsOfOffer * Y);
            discountAmountPerItem = totalDiscountForGroups / qtyToCheck;
            x.appliedOfferDescription = `BUY ${X} FOR FLAT ${Y}`;
          }
        }
      }

      // Calculate total price per item
      if (x.select_type == "weight" || (x.is_weight_type && (x.weight_price > 0 || x.inputMode === "weight"))) {
        currentPrice = x.weight_price || x.price; // Base price for weight items
        // Re-calculate discount for weight item if offer exists
        if (offer) {
          const Y = parseFloat(offer.Y) || 0;
          if (offer.type === "Flat % OFF") {
            discountAmountPerItem = (currentPrice * Y) / 100;
            x.appliedOfferDescription = `${Y}% OFF`;
          }
          // Add other weight-based offer types if needed here
        }
        x.totalPrice =
          (((x.weight || x.quantity) || 0) / 1000) * (currentPrice - discountAmountPerItem + addonsPrice);
        x.itemSubtotal = x.totalPrice;
      } else {
        x.totalPrice = (currentPrice - discountAmountPerItem + addonsPrice) * x.quantity;
        x.itemSubtotal = x.totalPrice;
      }
      x.itemDiscount = discountAmountPerItem * x.quantity;
      //x.name = x.appliedOfferDescription ? `${x.name} (${x.appliedOfferDescription})` : x.name;
      return x;
    });
    const itemsCount = orderItems.reduce((a, c) => a + (c.is_weight_type || c.inputMode === 'weight' ? 1 : (c.quantity || 1)), 0);
    setItemCount(itemsCount);
    let itemsPrice = orderItems.reduce((a, c) => a + c.totalPrice, 0);

    let txPerc = merchantData.taxPerc || merchantData.takeAwayTax || merchantData.itemInclusiveTax;
    let orderType = "Eat In";

    let discount = 0;
    const discountVal = parseFloat(discValue || 0);
    if (selectedDiscountMethod === "percentage") {
      discount = (itemsPrice * discountVal) / 100;
    } else {
      discount = discountVal;
    }

    let containerTotal = 0;

    if (merchantData?.bizVertical?.toLowerCase() == 'restaurant' && (containedIndex === 0 || containedIndex === 2)) {
      containerTotal = orderItems.reduce(
        (total, item) =>
          total + (parseFloat(item.container_price) || 0) *
          ((item.is_weight_type && item.weight_price > 0) ? 1 : item.quantity),
        0
      );
    }

    const taxableAmount = itemsPrice - discount;

    let taxPrice = txPerc
      ? parseFloat(((taxableAmount * txPerc) / 100).toFixed(2))
      : 0.0;

    if (merchantData?.itemInclusiveTax) {
      const rate = merchantData?.itemInclusiveTax || 0;
      // Extract tax from inclusive total
      let taxAmount = (taxableAmount * rate) / (100 + rate);
      taxPrice = taxAmount;
    }


    let serviceCharge = 0;
    if (merchantData?.bizVertical?.toLowerCase() == 'restaurant' && containedIndex == 1 && merchantData.dining_service_charge) {
      serviceCharge = parseFloat(((taxableAmount * merchantData.dining_service_charge) / 100).toFixed(2));
    }

    // --- Delivery charge ---
    let deliveryCharge = 0;
    if (containedIndex === 2) { // Delivery order type
      const feeType = merchantData?.deliveryFeeType;
      if (feeType === 'Fixed') {
        deliveryCharge = parseFloat(merchantData?.fixedDeliveryFee || 0);
      } else if (feeType === 'Dynamic Per X KM') {
        const perKm = parseFloat(merchantData?.dynamicDeliveryFeePerKm || 0);
        const cLat = parseFloat(order?.customerLat || 0);
        const cLng = parseFloat(order?.customerLng || 0);
        const mLat = parseFloat(merchantData?.latitude || merchantData?.location?.coordinates?.[1] || 0);
        const mLng = parseFloat(merchantData?.longitude || merchantData?.location?.coordinates?.[0] || 0);
        if (perKm > 0 && cLat && cLng && mLat && mLng) {
          const R = 6371;
          const dLat = ((cLat - mLat) * Math.PI) / 180;
          const dLng = ((cLng - mLng) * Math.PI) / 180;
          const a = Math.sin(dLat / 2) ** 2 +
            Math.cos((mLat * Math.PI) / 180) * Math.cos((cLat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
          const distKm = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          deliveryCharge = parseFloat((distKm * perKm).toFixed(2));
        }
      }
    }

    let totalPrice = 0;
    if (merchantData?.itemInclusiveTax) {
      totalPrice = Number(((itemsPrice - discount) + containerTotal + serviceCharge + deliveryCharge).toFixed(2));
    } else {
      totalPrice = Number((taxableAmount + taxPrice + containerTotal + serviceCharge + deliveryCharge).toFixed(2))
    }

    //console.log(order);
    let newOrder = {
      ...order,
      number: odr && odr.number ? odr.number : (order && order.number ? order.number : 0),
      isPaid: false,
      isReady: false,
      inProgress: true,
      isCanceled: false,
      isDelivered: false,
      orderType: getOrderType(),
      // customerId: custId,
      orderSource: "EPOS",
      paymentType: "At Counter",
      payGateOrderId: "",
      payVia: (function () {
        const modeMap = { 0: 'cash', 1: 'upi', 2: 'card', 3: 'coupon', 4: 'credit' };
        return modeMap[parseInt(merchantData?.defaultPaymentMethodPos)] || "cash";
      })(),
      currency: currency[0].abbreviation,
      orderStatus: "NEW",
      totalPrice: totalPrice,
      taxPrice: taxPrice,
      discountType: selectedDiscountMethod,
      discountAmount: discount,
      orderItems: orderItems,
      userId: merchCode,
      serviceCharge: serviceCharge,
      deliveryCharge: deliveryCharge,
      orderTakenById: userData.id || userData._id,
      paymentRefData: "",
      metaData: noteText
    };
    if (odr) {
      newOrder._id = odr._id;
    }
    if (order && order._id) {
      newOrder._id = order._id;
    }
    setOrder(newOrder);
    orderRef.current = newOrder;
    //console.log("newOrder---------------------------->", newOrder);
    // setTimeout(()=>updateCustomerDisplay(),1000);
    return newOrder;
  };

  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "/images/blank.jpg";
  };

  // console.log("invoiceNo", invoiceNo);

  // const getOrderPrintDetails = () => {
  //   orderDet = JSON.parse(localStorage.getItem("newOrder"));
  //   let orderData = {
  //     orderId: orderDet ? orderDet.id : "",
  //     merchantCode: merchCode ? merchCode : "",
  //     currency: currency.length && currency[0].abbreviation,
  //     restaurant: merchantData ? merchantData.firstName : "",
  //     address: (userData || merchantData) ? merchantData.address || userData.address : "",
  //     cgst: merchantData.taxPerc,
  //     taxPerc: merchantData.taxPerc,
  //     invoice_no: invoiceNo,
  //     receiptNote: merchantData.receiptNotes || "",
  //     cashier: userData?.name || merchantData?.firstName || "",
  //     locale: localStorage.getItem('locale'),
  //     kitchens: kitchens,
  //     cashOut: orderDet.cashOut || parseFloat(cashOut) || 0,
  //     customer: orderDet.customer || customerData,
  //     logoImg: merchantData.logoImg
  //   };
  //   if (orderDet.orderType == "Table Order" && merchantData?.dining_service_charge) {
  //     orderData['serviceCharge'] = merchantData.dining_service_charge;
  //   }
  //   console.log(orderData);
  //   return orderData;
  // }

  const getNewInvoice = (orderItms) => {
    return new Promise((resolve, reject) => {
      try {
        let billData = {};
        billData.userId = merchantData.merchantCode;
        billData.appName = "EPOS";
        billData.payType = "onetime";
        billData.payStatus = "paid";
        billData.purchaseItems = JSON.stringify(orderItms);

        axios
          .post(`${configs.payUrl}/api/new-order`, billData)
          .then((res) => {
            setInvoiceNo(res.data.invoiceData.invoicePath);
            setInvoiceId(res.data.invoiceData._id);
            console.log('got')
            resolve(res.data.invoiceData);
          });

      } catch (err) {
        reject(err);
      }
    })
  }

  const refundOrder = async (cartOrder) => {
    let finalCartOrder = cartOrder || order;
    if (!finalCartOrder) return;
    setOrderProcessing(true);
    let payload = { ...finalCartOrder };
    payload.orderItems = payload.orderItems.map(it => {
      return {
        ...it,
        sub_pro: typeof it.sub_pro == 'string' ? it.sub_pro : JSON.stringify(it.sub_pro)
      }
    });

    axios
      .post(
        `${baseURL}/api/orders?userId=${merchantData?.merchantCode || " "}`,
        payload
      )
      .then((res) => {
        // console.log("🆕 Order refund:", res.data);
        let ord = res.data;
        if (window.PrintInterface || window?.chrome?.webview?.postMessage) {
          //if (true) {
          ord.customer = finalCartOrder.customerPhone ? "Name:" + finalCartOrder?.customerName + ", Ph.:" + finalCartOrder?.customerPhone + ", Add.: " + finalCartOrder?.customerAddress : "";
          ord.isPaid = finalCartOrder.isPaid;
          ord.invoiceNo = ord.invoice_path || ord.invoicePath || invoiceNo || ord.invoice_no;
          ord.cashier = userData?.name || merchantData?.firstName || "";
          ord.receiptNote = merchantData.receiptNotes || "";
          printReceipt(ord, merchantData, [], t, formatter);
        }
        resetStates();
      })
      .catch((err) => {
        console.error("❌ Order creation failed:", err);
        setOrderProcessing(false);
      });
  }

  const createOrder = async (e, isOnlyKOT, isSaveOrder, cartOrder) => {
    let finalCartOrder = cartOrder || order;
    if (!finalCartOrder) return;
    setOrderProcessing(true);
    const currentOrdId = oid || finalCartOrder.id || ordId || localStorage.getItem("ordId");
    if (containedIndex === 1) {//table specific
      let tabId = localStorage.getItem("tableId");
      finalCartOrder.number = selectedTable;
      finalCartOrder.isPaid = false;
      finalCartOrder.isDelivered = false;
      finalCartOrder.tableId = tabId;
      finalCartOrder.invoiceId = invoiceId;
      updateTblStatus(selectedTable, !isSaveOrder);
    }
    if (!isOnlyKOT) {
      finalCartOrder.isPaid = true;
    }
    finalCartOrder.orderType = getOrderType();
    finalCartOrder.cashOut = parseFloat(cashOut) || 0;
    // finalCartOrder.customerId = custId;

    finalCartOrder.orderItems = finalCartOrder?.orderItems.map((it) => ({
      _id: it._id || it.id,
      kitchenId: it.kitchenId || "",
      container_price: (it.container_price || 0) *
        ((it.is_weight_type && it.weight_price > 0) ? 1 : it.quantity),
      quantity: it.quantity, // Holds weight (grams) or unit count
      select_type: it.select_type || "variety", // Default to variety
      price:
        (it.select_type === "weight" || (it.is_weight_type && it.weight_price > 0))
          ? it.weight_price
          : it.price +
          (it.sub_pro?.addons?.reduce((acc, val) => acc + val.price, 0) || 0), // Standard price calculation
      name: it.name,
      status: it.status ? it.status : "inProgress",
      appliedOfferDescription: it.appliedOfferDescription,
      sub_pro: typeof it.sub_pro == 'string' ? it.sub_pro : JSON.stringify(it.sub_pro),
      ...(finalCartOrder.isDelivered && { status: "delivered" }),
    }));

    let refinedOrd = updateOrderDetails(finalCartOrder.orderItems);
    let oItems = finalCartOrder.orderItems.map((oIt, i) => {
      oIt["totalPrice"] = formatter.format(refinedOrd.orderItems[i].totalPrice).replace('JMD', 'J$').replace(/\s+/, "");

      return oIt;
    });
    console.log("==order Items", oItems);
    finalCartOrder.orderItems = oItems;

    if (!isOnlyKOT) {
      let invData = await getNewInvoice();
      finalCartOrder.invoiceId = invData._id;
      finalCartOrder.invoice_path = invData.invoicePath;
      //console.log(invData);
    }
    finalCartOrder.discountType = selectedDiscountMethod;

    finalCartOrder.discountAmount = finalCartOrder.discountAmount;
    console.log('--------discount-', finalCartOrder.discountAmount);
    // Update or create order
    const orderCallback = (resData, isUpdate = false) => {

      const newId = resData.id || resData._id;
      let savedOrder = { ...resData, localOrderId: newId };
      if (!finalCartOrder.isPaid) {
        saveUpdateHoldOrd(finalCartOrder, true);
      }

      if (!isOnlyKOT) {
        //browser print
        if (window.PrintInterface || window?.chrome?.webview?.postMessage) {
          // if (true) {

          // let refinedOrd = updateOrderDetails(finalCartOrder.orderItems);
          // let oItems = refinedOrd.orderItems.map(oIt => {
          //   oIt.totalPrice = formatter.format(oIt.totalPrice).replace('JMD', 'J$').replace(/\s+/, "");

          //   return oIt;
          // })
          //console.log("==order Items", oItems);
          resData.customer = finalCartOrder.customerPhone ? "Name:" + finalCartOrder?.customerName + ", Ph.:" + finalCartOrder?.customerPhone + ", Add.: " + finalCartOrder?.customerAddress : "";
          resData.isPaid = finalCartOrder?.isPaid;
          resData.orderItems = oItems;
          resData.invoiceNo = resData.invoice_path || resData.invoicePath || finalCartOrder.invoice_path || invoiceNo || resData.invoice_no || resData.number;
          resData.changeAmount = finalCartOrder?.changeAmount;
          resData.discountAmount = finalCartOrder?.discountAmount;
          resData.cashier = userData?.name || merchantData?.firstName || "";
          resData.receiptNote = merchantData?.receiptNotes || ""
          printReceipt(resData, merchantData, kitchens, t, formatter);
        }

      } else {
        resData['tokenNo'] = "Token #" + resData.number;
        resData["header1"] = t({ id: "items" });
        resData["header2"] = t({ id: "quantity" });
        resData["header3"] = t({ id: "amountlbl" });
        resData["invoiceNo"] = t({ id: "invoice" }) + "#:" + (resData.invoice_path || resData.invoicePath || finalCartOrder.invoice_path || invoiceNo || resData.invoice_no || resData.number);
        let mDate = moment(resData.createdAt || new Date());
        if (merchantData?.timezone) {
          mDate = mDate.tz(merchantData.timezone);
        } else if (moment.tz.guess()) {
          mDate = mDate.tz(moment.tz.guess());
        }
        resData["date"] = mDate.format("DD-MMM-YYYY h:mm a");
        resData.orderItems = [];
        //let kitchensUsed =[];
        let AddorderItems =
          finalCartOrder &&
          finalCartOrder.orderItems &&
          finalCartOrder?.orderItems.map((item, index) => {
            const subPro = item.sub_pro ? JSON.parse(item.sub_pro) : {};
            const addonNames = subPro.addons
              ?.map((a) => a.name)
              .join(", ");
            const varietyNames = subPro.variety
              ? Object.keys(subPro.variety).join(", ")
              : "";
            const cookInst = subPro.cookInstructions.join(',');
            item.price =
              formatter.format(item.price).replace('JMD', 'J$').replace(/\s+/, "");
            item.quantity = (item.select_type === "weight" || (item.is_weight_type && item.weight_price > 0))
              ? `${(item.quantity / 1000).toFixed(2)}K/L `
              : item.quantity;
            item.addOnsStr = addonNames;
            item.varNames = varietyNames;
            item.notes = cookInst;
            // if(item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1){
            //     kitchensUsed.push(item.kitchenId);
            // }
            resData.orderItems.push(item);
          });
        if (window.PrintInterface || window?.chrome?.webview?.postMessage) {
          printKOT(resData);
        }

      }
      resetStates();
    };

    if (currentOrdId) {
      // Update existing order
      axios
        .put(
          `${baseURL}/api/orders/${currentOrdId}?userId=${merchantData?.merchantCode || " "
          }`,
          finalCartOrder
        )
        .then((res) => {
          console.log("✅ Order updated:", res.data);
          setOrderProcessing(false);
          orderCallback(res.data, true);
        })
        .catch((err) => {
          console.error("❌ Order update failed:", err);
          setOrderProcessing(false);
        });
    } else {
      // Create new order
      axios
        .post(
          `${baseURL}/api/orders?userId=${merchantData?.merchantCode || " "}`,
          finalCartOrder
        )
        .then((res) => {
          setOrdId(res.data.id || res.data._id);
          setOrderProcessing(false);
          setSnackbarOpen(true);
          orderCallback(res.data, false);
        })
        .catch((err) => {
          console.error("❌ Order creation failed:", err);
          setOrderProcessing(false);
        });
    }
  };

  const updateTblStatus = (tblNumber, isAvailable) => {
    const tabupdate = tableData.find((tab) => tab.number == selectedTable);
    if (isAvailable == tabupdate.isAvailable) {
      return;
    }
    if (tabupdate) {
      axios
        .patch(
          `${baseURL}/api/tables/${tabupdate.id}/availability?merchantCode=${merchantData?.merchantCode || " "
          }`,

        )
        .then((res) => console.log("✅ Table updated:", res.data));
    }
  }

  const finishOrder = async (onlyKOT) => {
    setOrderProcessing(true);
    if (order) {
      order.invoiceId = "";
      const timestamp = new Date().toLocaleString();
      order.timestamp = timestamp;
      if (onlyKOT) {
        createOrder(null, true, true);
        // window.PrintInterface && printKOT(order);
      }
    }
    if (selectedTable) {
      getAllTables();
    }
    if (merchantData?.bizVertical?.toLowerCase() !== 'retail') {
      setNewOrder(true);
    }

  };

  // Preload error sound
  const errorSound = new Audio("/no-sku.mp3"); // Place file in public/sounds/

  // Function to play sound safely
  const playErrorSound = () => {
    try {
      errorSound.currentTime = 0; // Restart sound if already playing
      errorSound.play().catch(() => {
        console.warn("Audio playback failed (possibly due to browser autoplay policy).");
      });
    } catch (err) {
      console.error("Error playing sound:", err);
    }
  };

  const printKOT = (order) => {

    let printDetails = JSON.parse(JSON.stringify(order));
    console.log(printDetails);
    let kitchensUsed = [];
    let filterKitchenUsed = order?.orderItems.map((item, index) => {
      if (item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1) {
        kitchensUsed.push(item.kitchenId);
      }
    });

    if (kitchensUsed.length) {
      let kitchPrintIndx = 0;
      let kitchPrintTimer = null;

      function sendForKOTPrint() {
        if (kitchPrintIndx >= kitchensUsed.length) {
          clearTimeout(kitchPrintTimer);
          kitchPrintIndx = 0; // Reset for next time (optional)
          return;
        }

        printDetails.printType = kitchensUsed[kitchPrintIndx];
        let isAndroid = false;
        if (window.PrintInterface) {
          isAndroid = true;
          window.PrintInterface.print(JSON.stringify(printDetails));
        }
        if (!isAndroid && window?.chrome?.webview?.postMessage) {
          window.chrome.webview.postMessage(printDetails);
        }

        kitchPrintIndx++;
        kitchPrintTimer = setTimeout(sendForKOTPrint, 15 * 1000);
      }

      sendForKOTPrint();
    } else {
      printDetails.printType = "KOT";
      window.PrintInterface && window.PrintInterface.print(JSON.stringify(printDetails));
      if (window?.chrome?.webview?.postMessage) {
        window.chrome.webview.postMessage(printDetails);
      }
    }

  }

  const saveUpdateHoldOrd = (order, toBeRemoveFrmHold) => {
    let HOs = localStorage.getItem("ordersOnHold");
    if (HOs) {
      HOs = JSON.parse(HOs);
      let savedIndx = HOs.findIndex(ho => ((ho.customerId && ho.customerId == order.customerId) || (order.number && ho.number == order.number)));
      if (savedIndx > -1) {
        HOs.splice(savedIndx, 1);
      }
      !toBeRemoveFrmHold && HOs.push(order);
      localStorage.setItem("ordersOnHold", JSON.stringify(HOs));
    } else {
      localStorage.setItem("ordersOnHold", JSON.stringify([order]));
    }
    resetStates();
  }

  const getContainIndx = (oType) => {

    let containedIndex = 3;
    if (oType == "Take Away") {
      containedIndex = 0;
    } else if (oType == "Table Order") {
      containedIndex = 1;
    } else if (oType == "Delivery") {
      containedIndex = 2;
    }
    else if (oType == "Eat In") {
      containedIndex = 3;
    }
    else if (oType == "Party Order") {
      containedIndex = 4;
    }
    else if (oType == "Refund") {
      containedIndex = 5;
    }
    return containedIndex;
  }

  const getOrderType = () => {
    let orderType = "Eat In";
    if (containedIndex === 0) {
      orderType = "Take Away";
    } else if (containedIndex === 1) {
      orderType = "Table Order";
    } else if (containedIndex === 2) {
      orderType = "Delivery";
    } else if (containedIndex === 3) {
      orderType = "Eat In";
    }
    else if (containedIndex === 4) {
      orderType = "Party Order";
    }
    else if (containedIndex === 5) {
      orderType = "Refund";
    }
    return orderType;
  }

  const handleHold = () => {
    if (order) {
      order.number = selectedTable;
      order.discountType = selectedDiscountMethod;
      order.discountAmount = parseFloat(discValue);
      const timestamp = new Date().toLocaleString();
      order.timestamp = timestamp;
      order.orderType = getOrderType();
      saveUpdateHoldOrd(order);
      if (containedIndex === 1 && selectedTable) {
        updateTblStatus(selectedTable, false);
        let isOrderwithPrint = true;
      }
    }
    resetStates();
  };

  const resetStates = () => {
    setOrderProcessing(false);
    setOrderItem([]);
    setOrder();
    setDiscValue(0);
    setPrice();
    setPercent();
    setIsPayment(false);
    setPlaceOrder(true);
    setDialogStep(1);
    setIsDropdownOpen(false);
    setSelectedDiscountMethod("");
    setCustomInstr("");
    setSelectedVar({});
    setSelectedTable("");
    setContainedIndex(getContainIndx(merchantData.defaultOrderType));
    setOrdId("");
    getAllTables();
    setItemCount(0);
    //setCookInst("");
    setCustomInstr("");
    setNoteText("");
    setShowCartIcon(true);
    setShowNoteInput(false);
    if (merchantData?.bizVertical?.toLowerCase() !== 'retail') {
      setNewOrder(true);
    }
    setCashOut("");
    setEditingIndex(null);
    setSearchText("");
    setIsSearch(false);
    handleBack();
    setTimeout(function () {
      if (window.OrdersUpdateInterface) {
        //if (true) {
        // console.log('--------************', updatedOrder);
        window.OrdersUpdateInterface.update(JSON.stringify({ orderItems: [], totalPrice: 0 }));
      }
    }
      , 700);
  }

  const getAllTables = () => {
    if (merchantData?.bizVertical?.toLowerCase() === 'retail') return;

    axios
      .get(`${baseURL}/api/tables?merchantCode=${merchCode}`)
      .then((res) => {
        setTableData(res.data);
      });
  }

  useEffect(() => {
    getAllTables();

  }, []);


  const resumeOrder = (holdIndx) => {

    const HOs = JSON.parse(localStorage.getItem("ordersOnHold")) || [];
    const resumeOrd = HOs[holdIndx];
    if (resumeOrd) {
      //    if(resumeOrd.customerId && resumeOrd.customerName){
      //   let customer = {
      //     id : resumeOrd.customerId,
      //     firstName :resumeOrd.customerName,
      //     email: resumeOrd.email,
      //     address: resumeOrd.customerAddress,
      //     phone:resumeOrd.customerPhone
      //   };
      //   handleCustomerSelect(customer);
      // }
      // if(resumeOrd.customerId){
      //   getCustomerById(resumeOrd.customerId);
      // }
      setOrder(resumeOrd);
      setOrderItem(resumeOrd.orderItems);
      updateOrderDetails(resumeOrd.orderItems);
      setOrdId(resumeOrd.id);
      if (resumeOrd.orderType == 'Table Order') {
        setSelectedTable(resumeOrd.number);
        handleOrderTypeTabClick(1);
      }
      setContainedIndex(getContainIndx);
      setHoldOpen(false);
      handleCancelOrd(holdIndx);
    }
  };


  const handleCancelOrd = (index) => {
    const orderResume = JSON.parse(localStorage.getItem("ordersOnHold"));
    if (index !== -1) {
      orderResume.splice(index, 1);
      localStorage.setItem("ordersOnHold", JSON.stringify(orderResume));
      setHoldOpen(false);
    }
    getAllTables();
  };


  const categoryClickHandler = (catName, catId, isAddOn) => {
    let prodAsPerCat = totalProducts.filter((p) => p.category == catId);
    setProducts(prodAsPerCat);
    setSelectedCat(catId);
  };

  const handleItem = () => { };

  const handleBack = () => {
    //console.log('----------bakc caled');
    setShowOrders(false);
    setShowProducts(true);
    setShowCartIcon(true);
    if (document.getElementById("bar")) {
      document.getElementById("bar").style.display = "flex";
    }
  };

  const handlePayMode = (mode, runningorder, payRefdata, splitPayMode, splitPayAmnt, changeAmount) => {
    // console.log(splitPayMode);
    // console.log(changeAmount);
    let payModeNm = '';
    const modeMap = {
      0: 'cash',
      1: 'upi',
      2: 'card',
      3: 'coupon',
      4: 'credit'
    };
    payModeNm = modeMap[payModeIndx];

    let ordexist = runningorder || order;
    let ord = { ...ordexist };
    ord.paymentState = "PAID";
    ord.isPaid = true;
    ord.payVia = payModeNm || mode || "upi";
    ord.paymentRefData = payRefdata ? (typeof payRefdata == 'object' ? JSON.stringify(payRefdata) : payRefdata) : ordexist.paymentRefData;
    if (payModeNm == 'cash') {
      ord.splitPayVia = ordexist?.splitPayMode || splitPayMode || (payModeNm == 'cash' && ord.paymentRefData ? "CARD" : "");
      ord.splitAmount = ord.splitPayVia ? (ordexist?.splitPayAmnt || splitPayAmnt || (ord.paymentRefData ? JSON.parse(ord.paymentRefData).total_amount : 0)) : "";
    }
    ord.changeAmount = changeAmount || 0;
    //console.log(ord);

    if (merchantData?.bizVertical?.toLowerCase() === 'retail' && ord?.orderType?.toLowerCase() === 'take away') {
      if (ord?.orderType?.toLowerCase() == "refund") {
        refundOrder(ord);
      } else {
        createOrder(null, false, false, ord);
      }
    } else {
      setOrder(ord);
    }
  };



  const closeHandler = () => {
    setIsOpen(false);
    setDialogStep(1);
    setIsDropdownOpen(false);
    setSelectedDiscountMethod("");
    setEditingIndex(null);
  };

  const handlediscsubmit = () => {
    const valuedisc = parseFloat(discValue);
    // console.log(selectedDiscountMethod);

    if (selectedDiscountMethod === "percentage") {
      const taxPrice = order.totalPrice * (valuedisc / 100);
      const percent = order.totalPrice - taxPrice;
      const formattedPercent = percent.toFixed(2); // Display percent with 2 decimal places
      // console.log(formattedPercent);
      setPercent(parseFloat(formattedPercent)); // Set the value as a number
    } else {
      const discValue = order.totalPrice - valuedisc;
      const formattedDiscValue = discValue.toFixed(2); // Display discount value with 2 decimal places
      setPrice(parseFloat(formattedDiscValue)); // Set the value as a number
      // console.log(order.totalPrice);
    }

    setIsDropdownOpen(false);
  };

  const showCategories = () => {
    const displayMode = merchantData?.eposCategoryDisplay || 'chips_scroll';

    if (displayMode === 'float_button') return null;
    if (displayMode === 'cards' && !selectedCat && !isSearch) return null;

    const isMultiline = displayMode === 'chips_multiline';

    return (
      <div
        className={"cat_cont"}
        style={isMultiline ? {
          flexWrap: 'wrap',
          overflowX: 'visible',
          height: 'auto',
          whiteSpace: 'normal',
          justifyContent: 'center'
        } : {}}
      >
        <div
          onClick={handleAllCategory}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            marginLeft: "10px",
            marginBottom: isMultiline ? '10px' : '0'
          }}
        >
          {merchantData?.show_category_images && (
            <img
              src={"/images/cat_logo.jpeg"}
              className={"cat_epos_icon"}
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: !selectedCat ? '2px solid #1976d2' : 'none'
              }}
            />
          )}
          <div
            className={!selectedCat ? "chip selected-chip" : "chip"}
            style={{ marginTop: "4px" }}
          >
            All
          </div>
        </div>
        {cat &&
          cat
            .filter((ct) => ct.isOrderableAlone || !ct.isAddOn)
            .map((category) => {
              let cId = category._id || category.id;

              return (
                <div
                  key={cId}
                  onClick={() =>
                    categoryClickHandler(category.name, cId, category.isAddOn)
                  }
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    marginLeft: "10px",
                    marginBottom: isMultiline ? '10px' : '0'
                  }}
                >
                  {merchantData.show_category_images && (
                    <img
                      src={category.image}
                      alt={category.name}
                      className="cat_epos_icon"
                      onError={(e) => (e.target.src = "/images/blank.jpg")}
                      style={{
                        display: "block",
                        margin: "0 auto",
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        border: category.id === selectedCat ? '2px solid #1976d2' : 'none'
                      }}
                    />
                  )}

                  <div
                    className={
                      category.id === selectedCat
                        ? "chip selected-chip"
                        : "chip"
                    }
                    style={{ marginTop: "4px" }}
                  >
                    {category.name}
                  </div>
                </div>
              );
            })}
      </div>
    );
  };

  window.onafterprint = () => {
    setPaymentAndBillDialog(false);
    //setShowBillBtn(false);
  };

  const handleEdit = () => {
    // setOpenPhone(true);
    // setExistingData({
    //   phoneNo: phnumber,
    //   Name: name,
    //   Address: address,
    // });
  };
  // console.log(order);

  const handleAllCategory = () => {
    setProducts(totalProducts);
    setSelectedCat("");
  };

  const showdialogForAddons = () => {
    let adonsCats = categories.filter(
      (cat) => selectedProduct.add_ons.indexOf(cat.id) != -1
    );
    return (
      <Box className="boxdialog">
        <Dialog
          onClose={closeHandler}
          aria-labelledby="max-width-dialog-title"
          open={isOpen}
          fullWidth={true}
        >
          <div id="dbox">
            <h2 style={{ textAlign: "center" }}>{selectedProduct.name}</h2>
            <Box id="adionorder" style={{ margin: "10px" }}>
              {variety && Object.keys(variety).length ? (
                <h4 style={{ textAlign: "center" }}>{"SELECT SIZE"}</h4>
              ) : (
                ""
              )}
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                {showVarietyBtn(variety)}
              </div>

              {adonsCats.length
                ? adonsCats.map((aoCat, i) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignContent: "center",
                      padding: "3px 15px",
                      fontSize: "20px",
                      flexWrap: "wrap",
                      marginBottom: "20px",
                    }}
                  >
                    <h3
                      style={{
                        width: "100%",
                        margin: "5px",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      <b> {aoCat.name}</b>
                    </h3>
                    <div className="textsmall_b">
                      {"(Min. " +
                        aoCat.minAddOnAllowed +
                        ", Max " +
                        aoCat.maxAddOnAllowed +
                        ")"}
                    </div>
                    {totalProducts
                      .filter((aopi) => aopi.category == aoCat.id)
                      .map((pi) => (
                        <div
                          className="chip-select"
                          style={{
                            backgroundColor: selAdons.some((ao) => ao.id == pi.id)
                              ? "#0cb600"
                              : "#c6c2c2",
                          }}
                        >
                          <Checkbox
                            id={`checkboxId-${i}`}
                            checked={selAdons.some((ao) => ao.id == pi.id)}
                            onChange={(e) => adAddons(e, pi.id, i, pi)}
                          />
                          <span> {pi.name} </span>
                          <b style={{ fontSize: "0.7em", color: "#fff" }}>
                            {selectedCurrency} {pi.price}
                          </b>
                        </div>
                      ))}
                  </div>
                ))
                : ""}

              <h4 style={{ textAlign: "center" }}>
                {t({ id: "select_cook_instruction" })}
              </h4>
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                {showinstructionBtn(cookInst)}
              </div>

              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Button
                  variant="outlined"
                  id="btn_cancel"
                  onClick={closeHandler}
                >
                  {t({ id: "cancel" })}
                </Button>
                <Button variant="contained" id="btnAdd" onClick={nextHandler}>
                  {t({ id: "Next" })}
                </Button>
              </Box>
            </Box>
          </div>
        </Dialog>
      </Box>
    );
  };
  const handleOrderTypeTabClick = (index) => {
    setContainedIndex(index);
    // updateOrderDetails();
  };

  const handlePaymentClick = (index) => {
    setPaymentIndex(index);
  };



  // console.log(order);

  const showOrdersItems = () => {

    return (
      <div className="pos_container">
        <div className="items">
          <div className="content" ref={cartRef}>
            <div>
              <ArrowBackIcon onClick={handleBack} id="back" />
              {isPortrait && <CancelIcon style={{ position: "absolute", right: "10px", top: "10px" }} onClick={() => (resetStates(), navigate(`/epos/`))} color="error" />}
              <table
                align="center"
                id="pos-items"
                cellPadding="5px"
                style={{ width: "100%" }}
              >
                <thead style={{ color: merchantData?.themeTxtColor }}>
                  <tr>
                    <th style={{ textAlign: "left" }}>ITEM</th>
                    <th>{t({ id: "price" })}</th>
                    <th style={{ width: "120px", textAlign: "center" }}>
                      Qty/Wt
                    </th>
                    <th style={{ textAlign: "right" }}>{t({ id: "total" })}</th>

                  </tr>
                </thead>
                <tbody>
                  {order && order.orderItems && order.orderItems.length
                    ? order?.orderItems?.map((item, indx) => {
                      const subProArray = typeof item.sub_pro == 'string' ? JSON.parse(item.sub_pro) : item.sub_pro;

                      console.log(subProArray);
                      const subProNames =
                        subProArray && subProArray.addons
                          ? subProArray.addons.map((subPro) => subPro.name)
                          : [];
                      const subVariety = subProArray
                        ? subProArray.variety
                        : "";
                      // console.log(order);
                      // console.log(subVariety);
                      return (
                        <>
                          <tr>
                            <td>
                              {" "}
                              <b>{item.name}</b>
                              <IconButton size="small" onClick={() => handleEditProduct(item, indx)}>
                                <EditIcon style={{ fontSize: '1rem', color: '#dcb41c' }} />
                              </IconButton>
                              <br />{" "}
                              {item.appliedOfferDescription ? <Chip
                                label={item.appliedOfferDescription.toUpperCase()}
                                color="primary"
                                variant="outlined"
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                }}
                              /> : ""}
                              {subProNames.length > 0 ? (
                                <Chip
                                  label={subProNames.join(",").toUpperCase()}
                                  color="primary"
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "10px",
                                    fontWeight: "bold",
                                  }}
                                />
                              ) : (
                                subProNames
                              )}{" "}
                              {subProArray &&
                                subProArray.cookInstructions &&
                                subProArray.cookInstructions.length ? (
                                <Chip
                                  label={subProArray.cookInstructions
                                    .join(",")}
                                  color="primary"
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "8px",
                                    fontWeight: "bold",
                                  }}
                                />
                              ) : (
                                ""
                              )}
                              {subVariety ? (
                                <Chip
                                  label={Object.keys(subVariety)
                                    .join(",")
                                    .toUpperCase()}
                                  color="primary"
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "10px",
                                    fontWeight: "bold",
                                  }}
                                />
                              ) : (
                                ""
                              )}

                            </td>
                            <td >
                              {item.is_weight_type &&
                                (item.weight_price > 0 || item.inputMode === "weight") ? (
                                <>
                                  {formatter.format(item.weight_price).replace('JMD', 'J$').replace(/\s+/, "")}/{item.weight_unit || "kg"}
                                </>
                              ) : (
                                <>
                                  {formatter.format(item.price +
                                    (subProArray?.addons?.reduce(
                                      (acc, val) => acc + val.price,
                                      0
                                    ) || 0)).replace('JMD', 'J$').replace(/\s+/, "")}

                                </>
                              )}

                              {item.isPriceEditable && (
                                <EditIcon
                                  style={{ height: "20px" }}
                                  onClick={() => setEditPriceDialog(indx + 1)}
                                />
                              )}
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                {item.is_weight_type &&
                                  (item.weight_price > 0 || item.inputMode === "weight") ? (
                                  <>
                                    {/* Weight input */}
                                    <TextField
                                      type="string"
                                      size={'small'}
                                      placeholder={"gm/ml"}
                                      endAdornment={<InputAdornment position="end">{"gm/ml"}</InputAdornment>}
                                      value={item.weight !== undefined && item.weight !== null ? item.weight : ""}
                                      onChange={(e) => {
                                        const valStr = e.target.value;
                                        const gram = parseFloat(valStr) || 0;
                                        const newOrderItems = [
                                          ...order.orderItems,
                                        ];
                                        newOrderItems[indx].weight = valStr;
                                        newOrderItems[indx].quantity = gram; // Save weight into quantity
                                        //setOrderItem(newOrderItems);
                                        updateOrderDetails(newOrderItems);
                                      }}
                                      inputProps={{
                                        min: 0,
                                        maxLength: 8,
                                        style: {
                                          width: "80px",
                                          color: "#1b1616ff",
                                          border: "1px solid #5e5c5cff",
                                          borderRadius: "5px"

                                        },
                                      }}
                                    />
                                    <RefreshIcon
                                      style={{ cursor: "pointer", marginLeft: "5px", color: "#1976d2" }}
                                      onClick={() => {
                                        selectedWindexRef.current = indx;
                                        setSelectedWindex(indx);
                                        if (window.WeightRequestInterface) {
                                          window.WeightRequestInterface.sendCommand();
                                        }
                                      }}
                                    />
                                    {/* Toggle to Quantity - REMOVED AS PER REQUIREMENT */}
                                  </>
                                ) : (
                                  <>
                                    {/* Quantity controls */}
                                    <button
                                      className="add_btn"
                                      onClick={() => handleRemove(indx)}
                                      style={{
                                        display:
                                          item.status === "ready" ||
                                            item.status === "delivered"
                                            ? "none"
                                            : "inline-block",
                                      }}
                                    >
                                      <RemoveIcon />
                                    </button>
                                    <span
                                      style={{
                                        margin: "0px 8px",
                                        minWidth: "24px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.quantity}
                                    </span>
                                    <button
                                      className="add_btn"
                                      onClick={() => handleAdd(indx)}
                                      style={{
                                        display:
                                          item.status === "ready" ||
                                            item.status === "delivered"
                                            ? "none"
                                            : "inline-block",
                                      }}
                                    >
                                      <AddIcon />
                                    </button>
                                    {/* Toggle to Weight - REMOVED AS PER REQUIREMENT */}
                                  </>
                                )}
                              </div>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {formatter.format(item.totalPrice).replace('JMD', 'J$').replace(/\s+/, "")}
                              <CancelIcon
                                style={{ cursor: "pointer", fontSize: "1.2rem", color: "#d32f2f" }}
                                onClick={() => deleteItem(indx)}
                              />
                            </td>

                          </tr>
                        </>
                      );
                    })
                    : ""}
                  {(() => {
                    console.log(order);
                    const subTotal = order && order.orderItems && order.orderItems.length
                      ? order?.orderItems.reduce((total, item) => {
                        return total + item.totalPrice;
                      }, 0)
                      : 0;


                    let serviceCharge = 0;
                    if (containedIndex == 1) {
                      serviceCharge = subTotal * (merchantData.dining_service_charge / 100);
                    }
                    const tax = order?.taxPrice || 0;

                    const containerPrice =
                      containedIndex === 0 || containedIndex === 2
                        ? order?.orderItems?.reduce(
                          (total, item) =>
                            total +
                            (parseFloat(item.container_price) || 0) *
                            ((item.is_weight_type && item.weight_price > 0) ? 1 : (item.quantity || 1)),
                          0
                        )
                        : 0;

                    const grandTotal = order?.totalPrice || 0;

                    let taxFormatted = tax.toFixed(2);;


                    return (
                      <>
                        <tr>
                          <td
                            colSpan={isPortrait ? "2" : "3"}
                            align="left"
                            style={{ color: "#dcb41c" }}
                          >
                            Subtotal
                          </td>
                          <td style={{ textAlign: "right" }}>
                            <b>
                              {formatter.format(subTotal).replace('JMD', 'J$')}
                            </b>
                          </td>
                        </tr>

                        {order?.discountAmount > 0 ? (
                          <tr>
                            <td
                              colSpan={isPortrait ? "2" : "3"}
                              align="left"
                              style={{ color: "#eda58e" }}
                            >
                              Discount
                            </td>
                            <td style={{ textAlign: "right", color: "#eda58e" }}>{'- ' + formatter.format(order?.discountAmount).replace('JMD', 'J$')}</td>
                          </tr>
                        ) : ""}

                        {taxFormatted > 0 ? <tr>
                          <td
                            colSpan={isPortrait ? "2" : "3"}
                            align="left"
                            style={{ color: "#dcb41c" }}
                          >
                            Tax {merchantData?.itemInclusiveTax ? "(Inclusive)" : "(Exclusive)"}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {selectedCurrency} {taxFormatted}
                          </td>
                        </tr> : ""}

                        {containedIndex == 1 && merchantData.dining_service_charge && serviceCharge ? <tr>
                          <td
                            colSpan={isPortrait ? "2" : "3"}
                            align="left"
                            style={{ color: "#dcb41c" }}
                          >
                            Service Charge
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {selectedCurrency} {serviceCharge.toFixed(2)}
                          </td>
                        </tr> : ""}

                        {containerPrice > 0 ? (
                          <tr>
                            <td
                              colSpan={isPortrait ? "2" : "3"}
                              align="left"
                              style={{ color: "#dcb41c" }}
                            >
                              Container
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {formatter.format(containerPrice).replace('JMD', 'J$').replace(/\s+/, "")}
                            </td>
                          </tr>
                        ) : ""}

                        {containedIndex === 2 && order?.deliveryCharge > 0 ? (
                          <tr>
                            <td
                              colSpan={isPortrait ? "2" : "3"}
                              align="left"
                              style={{ color: "#6ec6f5" }}
                            >
                              🚚 Delivery Charge
                              {merchantData?.deliveryFeeType === 'Dynamic Per X KM' && order?.customerLat && order?.customerLng && (() => {
                                const cLat = parseFloat(order.customerLat);
                                const cLng = parseFloat(order.customerLng);
                                const mLat = parseFloat(merchantData?.latitude || merchantData?.location?.coordinates?.[1] || 0);
                                const mLng = parseFloat(merchantData?.longitude || merchantData?.location?.coordinates?.[0] || 0);
                                if (!cLat || !cLng || !mLat || !mLng) return null;
                                const R = 6371;
                                const dLat = ((cLat - mLat) * Math.PI) / 180;
                                const dLng = ((cLng - mLng) * Math.PI) / 180;
                                const a = Math.sin(dLat / 2) ** 2 +
                                  Math.cos((mLat * Math.PI) / 180) * Math.cos((cLat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
                                const distKm = (R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))).toFixed(1);
                                return <span style={{ fontSize: '0.75em', color: '#aaa', marginLeft: 4 }}>({distKm} km)</span>;
                              })()}
                            </td>
                            <td style={{ textAlign: "right", color: "#6ec6f5" }}>
                              {formatter.format(order.deliveryCharge).replace('JMD', 'J$').replace(/\s+/, "")}
                            </td>
                          </tr>
                        ) : ""}

                        <tr>
                          <td
                            colSpan={isPortrait ? "1" : "2"}
                            align="left"
                            style={{ color: "#dcb41c", fontSize: "1.2em" }}
                          >
                            <b>{`Total(#${order?.orderItems?.length})`}</b>
                          </td>
                          <td colSpan={isPortrait ? "2" : "3"} align="right" style={{ textAlign: "right" }}>
                            <b style={{ fontSize: "1.6em" }}>
                              {formatter.format(grandTotal).replace('JMD', 'J$')}
                            </b>
                          </td>
                        </tr>
                      </>
                    );
                  })()}
                </tbody>
              </table>
            </div>

            <div id="disc">
              {order && order.totalPrice ? (
                <Button
                  variant="outlined"
                  className="btn-border"
                  id="discbtn"
                  onClick={handledisc}
                >
                  {t({ id: "discount" })}
                </Button>
              ) : ""}

              {isDropdownOpen && (
                <div id="sel1">
                  <div>
                    <Button
                      color="success"
                      onClick={() => setSelectedDiscountMethod("percentage")}
                      variant={selectedDiscountMethod == "percentage" ? "contained" : "outlined"}
                      value="percentage"
                    >
                      Percent(%)
                    </Button>
                    <Button
                      color="success"
                      onClick={() => setSelectedDiscountMethod("price")}
                      variant={selectedDiscountMethod == "price" ? "contained" : "outlined"}
                      value="price"
                    >
                      {"Fix( " + merchantData.currency + " )"}
                    </Button>
                    {false && (
                      <Button
                        onClick={handleDiscountMethodSelect}
                        variant="outlined"
                        value="coupon"
                      >
                        Coupon
                      </Button>
                    )}
                  </div>
                </div>
              )}
              {selectedDiscountMethod &&
                <TextField
                  id="discval"
                  size="small"
                  variant="outlined"
                  type="number"
                  value={discValue}
                  onChange={(e) => setDiscValue(e.target.value)}
                  onBlur={() => updateCustomerDisplay()}
                  style={{
                    display: "inline-block",
                    borderRadius: "10px",
                    width: "150px",
                    backgroundColor: "#577283",
                  }}
                />
              }


            </div>
            <div>
              <Button
                variant="contained"
                color="success"
                style={
                  selectedDiscountMethod
                    ? { display: "none" }
                    : { display: "none" }
                }
                onClick={handlediscsubmit}
              >
                {t({ id: "apply" })}
              </Button>

              <div>

                {/* Note input – expands below Note button */}

                {order && order.totalPrice ? <div id="note-input-panel" style={{ marginBottom: "15px", textAlign: "right", flexDirection: "column", gap: "2px" }}>
                  <TextField
                    id="noteTextInput"
                    size="small"
                    variant="outlined"
                    multiline
                    minRows={1}
                    maxRows={1}
                    placeholder="Add order note..."
                    value={noteText}
                    onChange={(e) => {
                      setNoteText(e.target.value);
                    }}
                    onBlur={() => {
                      updateOrderDetails();
                      setShowNoteInput(false);
                    }}
                    style={{
                      backgroundColor: "#577283",
                      borderRadius: "8px",
                      width: "300px",
                    }}
                    inputProps={{ style: { color: "#fff", margin: "5px", fontSize: "1em" } }}
                  />
                </div> : ""}


              </div>

            </div>
            {order && order.totalPrice && merchantData && merchantData.isCashOut ?
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <label for="cashouttxt" style={{ color: "#dcb41c", fontSize: "14px", marginLeft: "10px", fontWeight: "bold" }}>{t({ id: "cashout" })}</label>
                <TextField
                  id="cashouttxt"
                  size="small"
                  type="number"
                  placeholder={t({ id: "cashout" })}
                  value={cashOut}
                  onChange={(e) => setCashOut(e.target.value)}
                  style={{
                    display: "inline-block",
                    borderRadius: "10px",
                    width: "150px",
                    backgroundColor: "#577283",
                  }}
                />
              </div> : ""

            }
          </div>

          <div
            className="footer"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "column",
              padding: "10px"
            }}
          >

            <div>
              {order && order.isPaid ? <span style={{ paddingBottom: "10px", marginBottom: "10px", display: 'flex', alignItems: 'center', gap: '5px' }}> <Chip
                label="✔ PAID"
                color="success"
                style={{
                  fontSize: "x-small",
                  fontWeight: "bold",
                  marginBottom: "20px"
                }}
              />
                {merchantData?.show_customer_display ? <MonitorIcon onClick={() => updateCustomerDisplay()} style={{ color: "#0cb600", marginBottom: "20px" }} /> : ""}
              </span> : <div style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingBottom: "10px", marginBottom: "10px" }}>
                {
                  order && !orderProcessing &&
                    (order?.orderItems?.length) &&
                    !(order?.orderItems.some(
                      (item) =>
                        item.is_weight_type &&
                        item.inputMode === "weight" &&
                        (item.weight === 'NaN' || item.weight <= 0)
                    )) ?
                    <PaymentOptions
                      handlePaymentClick={handlePaymentClick}
                      handlePayMode={handlePayMode}
                      userData={merchantData}
                      loggedInUser={userData}
                      setPayModeIndx={setPayModeIndx}
                      payModeIndx={payModeIndx}
                      order={order}
                      cashout={cashOut}
                      setIsTerminalPopupOpen={setIsTerminalPopupOpen}
                      closeParentDialog={() => setPayModeSelectDialog(false)}
                    /> : <span style={{ color: "#dc1c1cff", marginLeft: "20px" }}>Cart is empty or weight not entered</span>}
                {merchantData?.show_customer_display ? <MonitorIcon onClick={() => updateCustomerDisplay()} style={{ color: "#dcb41c", marginLeft: "20px" }} /> : ""}
              </div>}
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
                marginBottom: "10px"

              }}
            >
              {!isPortrait ? <CancelIcon onClick={() => (resetStates(), navigate(`/epos/`))} color="error" /> : ""}

              {/* Conditionally render Resume or Save button */}
              {order && order.orderItems?.length > 0 ? (
                <Button
                  variant="outlined"
                  className="btn-border"
                  onClick={handleHold}
                  disabled={!order}
                >
                  {t({ id: "save" })}
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  className="btn-border"
                  onClick={() => setHoldOpen(true)}
                >
                  {t({ id: "resume" })}
                </Button>
              )}


              <Button
                variant="contained"
                disabled={
                  !order || orderProcessing ||
                  !(order?.orderItems?.length) ||
                  order?.orderItems.some(
                    (item) =>
                      item.is_weight_type &&
                      item.inputMode === "weight" &&
                      (!item.weight || item.weight <= 0)
                  )
                }
                color={"warning"}
                onClick={order?.orderType?.toLowerCase() == "refund" ? refundOrder : createOrder}
              >
                {order?.orderType?.toLowerCase() == "refund" ? t({ id: "finish_refund" }) : t({ id: "finish_order" })}
              </Button>

              {merchantData?.bizVertical?.toUpperCase() == 'RESTAURANT' ? <Button
                variant="contained"
                disabled={
                  !order || !(order?.orderItems?.length) || orderProcessing ||
                  order?.orderItems.some(
                    (item) =>
                      item.is_weight_type &&
                      item.inputMode === "weight" &&
                      (!item.weight || item.weight <= 0)
                  )
                }
                color={"success"}
                onClick={() => finishOrder(true)}
              >
                {t({ id: "send_to_kitchen" })}
              </Button> : ""}

            </div>
          </div>
        </div>
      </div>
    );
  };

  const showProductsCard = () => {
    const showCatMode = merchantData?.eposCategoryDisplay === 'cards' && !selectedCat && !isSearch;

    if (showCatMode) {
      const orderableCats = cat.filter((ct) => ct.isOrderableAlone || !ct.isAddOn);
      return (
        <div
          className="product_container"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
            gap: "10px",
            padding: "10px",

          }}
        >
          {orderableCats.length ? (
            orderableCats.map((category, idx) => {
              let cId = category._id || category.id;
              return (
                <Card
                  key={cId}
                  style={{ minHeight: merchantData?.bizVertical?.toLowerCase() !== 'retail' ? '100px' : '100px' }}
                  onClick={() => categoryClickHandler(category.name, cId, category.isAddOn)}
                  className="product"
                >
                  <CardActionArea
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      padding: "8px",
                      boxSizing: "border-box",
                    }}
                  >
                    {merchantData?.show_category_images && category.image && (
                      <CardMedia
                        component="img"
                        alt={category.name}
                        image={category.image}
                        onError={imageOnErrorHandler}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginBottom: "8px",
                        }}
                      />
                    )}
                    <CardContent className="cardFooter" style={{ padding: "8px 0 0 0" }}>
                      <Box className="foot" style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="chip">
                          {category.name}
                        </div>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              );
            })
          ) : (
            <h5 className="text-danger">{"No Categories Found"}</h5>
          )}
        </div>
      );
    }

    return (
      <div
        className="product_container"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
          gap: "10px",
          padding: "10px",
          marginTop: "10px",
        }}
      >
        {merchantData?.eposCategoryDisplay === 'cards' && selectedCat && !isSearch && (
          <Card style={{ minHeight: merchantData?.bizVertical?.toLowerCase() !== 'retail' ? '100px' : '100px' }} onClick={handleAllCategory} className="product">
            <CardActionArea style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <ArrowBackIcon style={{ fontSize: '40px', color: '#577283' }} />
              <div className="chip" style={{ marginTop: '8px' }}>Back</div>
            </CardActionArea>
          </Card>
        )}
        {productItems.length ? (
          productItems.map((p) => {
            return (
              <>
                <Card style={{ minHeight: merchantData.bizVertical.toLowerCase() !== 'retail' ? '' : '100px' }} onClick={() => handleProduct(p)} className="product">
                  <CardActionArea
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      height: "100%",
                      padding: "8px",
                      boxSizing: "border-box",
                    }}
                  >
                    {merchantData.bizVertical.toLowerCase() !== 'retail' && <CardMedia
                      component="img"
                      alt={p.name}
                      onError={imageOnErrorHandler}
                      image={p.image}
                      onError={imageOnErrorHandler}
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "100px",
                        objectFit: "cover",
                        marginBottom: "8px",
                      }}
                    />}

                    <CardContent className="cardFooter">
                      <Box className="foot">
                        <Typography variant="h6" component="p" className="txtf">
                          {p.name.substring(0, 30)}
                        </Typography>
                        <b style={{ fontSize: "0.7em" }}>
                          {p.isPriceVariety && p.varietyPrices
                            ? Object.values(JSON.parse(p.varietyPrices)).join(
                              '/'
                            ) : formatter.format(p.price || p.weight_price).replace('JMD', 'J$').replace(/\s+/, "") + (p.price ? " /Q" : " /" + p.weight_unit)}
                        </b>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </>
            );
          })
        ) : (
          <h5 className="text-danger">{"No Item Found"}</h5>
        )}
      </div>
    );
  };
  const orderHold = localStorage.getItem("ordersOnHold");
  const orderHoldData = orderHold ? JSON.parse(orderHold) : "";

  return (
    <div
      className="main_po"

    >
      <div className="cart_and_items_holder" style={
        isleftAlign
          ? { flexDirection: "row-reverse" }
          : { flexDirection: "row" }
      }>
        <div className="orderlist">
          {showOrdersItems()}
          <style>
            {`
                @media (orientation: portrait) {
                    .orderlist {
                        display: ${showOrders ? "block !important" : "none !important"
              };
                    }
                }
                `}
          </style>
        </div>

        <div
          style={{
            display: showProducts ? "flex" : "none",
            flexDirection: "column",

            overflow: "hidden",
          }}
          className="productslist"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              backgroundColor: "#eceff3",
              padding: "10px 0",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              position: "relative"
            }}
          >

            <div
              style={
                containedIndex === 1
                  ? {
                    display: "inline-block",
                    alignItems: "center",
                  }
                  : { display: "none" }
              }
            >

              <Button onClick={handleTableDetail} id="butt">
                <TableBarIcon />
                <span style={{ fontSize: "2em" }}> {'#' + selectedTable}</span>
              </Button>
            </div>
            {merchantData?.bizVertical == 'retail' && <div style={{ display: 'flex', alignItems: 'center', flexDirection: "column" }}>
              <Switch
                size="small"
                checked={showWithoutSku}
                onChange={toggleWithoutSku}
                color="primary"
              />
              <Typography variant="body2" style={{ color: "#577283", marginTop: "10px" }}>No SKU</Typography>

            </div>}
            {merchantData?.bizVertical == 'retail' && <span style={{ color: '#bbb', fontSize: '1.5em', margin: '0 5px' }}>|</span>}
            <div className="search" style={{ display: 'flex', alignItems: 'center', margin: '0 15px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#fff',
                padding: '4px 16px',
                borderRadius: '30px',
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                maxWidth: '200px'
              }}>
                <input
                  type="text"
                  className="search_input"
                  placeholder="Search Item..."
                  id="search_menu"
                  value={searchText}
                  onChange={handleSearch}
                  onKeyDown={(e) => { if (e.key === 'Enter') applyFilter(); }}
                  style={{
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    fontSize: '14px',
                    width: '100%',
                    padding: '5px 5px',
                    color: '#333',
                    fontWeight: '500'
                  }}
                />
              </div>
              {isSearch && searchText.length > 0 ? (
                <CloseIcon
                  onClick={() => {
                    setSearchText("");
                    let fltData = totalProducts.filter(
                      (pro) =>
                        pro.inStock === true &&
                        (showWithoutSku ? !pro.SKU_id : true) &&
                        (selectedCat ? pro.category === selectedCat : true)
                    );
                    setFilterPro(fltData);
                    setIsSearch(showWithoutSku);
                  }}
                  style={{
                    color: '#d32f2f',
                    fontSize: '40px',
                    cursor: 'pointer',
                    marginLeft: '12px',
                    background: '#fff',
                    borderRadius: '50%',
                    padding: '6px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0'
                  }}
                />
              ) : (
                <SearchIcon
                  onClick={applyFilter}
                  style={{
                    color: '#fff',
                    fontSize: '40px',
                    cursor: 'pointer',
                    marginLeft: '12px',
                    background: '#171e25',
                    borderRadius: '50%',
                    padding: '6px',
                    boxShadow: '0 4px 10px rgba(25, 118, 210, 0.3)'
                  }}
                />
              )}
            </div>
            <span style={{ color: '#bbb', fontSize: '1.5em', margin: '0 5px' }}>|</span>
            <div className="customer" style={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }} onClick={() => setIsCustomerPopupOpen(true)}>
              <UserIcon style={{ fontSize: "2rem", color: "#577283" }} />
              {order?.customerPhone ? (
                <span style={{ fontSize: "0.85rem", display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
                  <strong style={{ color: "#333" }}>{order?.customerName || "Customer"}</strong>
                  <span style={{ fontSize: "0.75rem", color: "#666" }}>Ph: {order?.customerPhone}</span>
                  {(() => {
                    // GeoJSON stores [longitude, latitude]
                    const mLat = merchantData?.location?.coordinates?.[1] || merchantData?.latitude;
                    const mLng = merchantData?.location?.coordinates?.[0] || merchantData?.longitude;
                    const cLat = order?.customerLat;
                    const cLng = order?.customerLng;
                    if (mLat && mLng && cLat && cLng) {
                      const R = 6371;
                      const dLat = (cLat - mLat) * Math.PI / 180;
                      const dLon = (cLng - mLng) * Math.PI / 180;
                      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(mLat * Math.PI / 180) * Math.cos(cLat * Math.PI / 180) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);
                      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                      return <span style={{ fontSize: "0.75rem", color: "#1976d2", fontWeight: 500 }}>Dist: {(R * c).toFixed(2)} km</span>;
                    }
                    return null;
                  })()}
                </span>
              ) : (
                <span style={{ fontSize: "0.8rem", fontWeight: 500, color: "#577283" }}>Customer</span>
              )}
            </div>
            <span style={{ color: '#bbb', fontSize: '1.5em', margin: '0 5px' }}>|</span>
            <div className="orderType" onClick={() => setNewOrder(true)} style={{ marginRight: "10px", color: "#333", display: "flex", alignItems: "center", gap: "5px", flexDirection: "column" }}>
              {getOrderType().toUpperCase() == 'EAT IN' && <img
                height="30px"
                alt=""
                width="30px"
                src="/images/eat_in.png"
              />}
              {getOrderType().toUpperCase() == 'TAKE AWAY' && <img
                height="30px"
                alt=""
                width="30px"
                src="/images/take-out-2.png"
              />}
              {getOrderType().toUpperCase() == 'TABLE ORDER' && <img
                height="25px"
                alt=""
                width="25px"
                src="/images/tableOrder.png"
              />}
              {getOrderType().toUpperCase() == 'DELIVERY' && <DeliveryDiningIcon
                style={{ height: "25px", width: "25px" }}
              />}
              {getOrderType().toUpperCase() == 'REFUND' && <ShoppingCartCheckoutIcon
                style={{ height: "25px", width: "25px" }}
              />}
              <span>
                <span style={{ color: "#577283", fontSize: "0.8em" }}>{getOrderType()}</span>
                {false && <EditIcon
                  style={{ cursor: "pointer", fontSize: "1.2rem", color: "#1976d2" }}
                  onClick={() => setNewOrder(true)}
                />}
              </span>
            </div>
          </div>


          {showCategories()}


          <div className="products-epos-list" style={{ position: 'relative' }}>
            {showProductsCard()}
            {merchantData?.eposCategoryDisplay === 'float_button' && (
              <div style={{
                position: 'absolute',
                bottom: '15px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000
              }}
                onClick={(e) => setCatAnchorEl(e.currentTarget)}
              >
                <Fab

                  style={{
                    backgroundColor: '#000',
                    color: '#fff'
                  }}
                >
                  <MenuIcon />

                </Fab>
                <span style={{ fontSize: "1em", fontWeight: "bold" }}> CATEGORIES</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {showCartIcon ? <span id="bar" onClick={handleOrder}>
        <span className="cart_count">{order?.orderItems?.length}</span>
        <ShoppingBagIcon sx={{ cursor: "pointer", color: "white" }} />
      </span> : ""}
      {selectedProduct && showdialogForAddons()}

      <Popover
        open={Boolean(catAnchorEl)}
        anchorEl={catAnchorEl}
        onClose={() => setCatAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0)',
            color: '#fff',
            borderRadius: '12px',
            padding: '10px',
            maxWidth: '350px'
          }
        }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
          <div
            onClick={() => { handleAllCategory(); setCatAnchorEl(null); }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: 'pointer',
              padding: '8px',
              borderRadius: '8px',
              backgroundColor: !selectedCat ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
              width: 'auto'
            }}
          >
            {merchantData?.show_category_images && (
              <img
                src={"/images/cat_logo.jpeg"}
                className={"cat_epos_icon"}
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: !selectedCat ? '2px solid #fff' : 'none'
                }}
              />
            )}
            <div style={{ marginTop: "4px", fontSize: '16px', textAlign: 'center' }}>
              All
            </div>
          </div>
          {cat && cat.filter((ct) => ct.isOrderableAlone || !ct.isAddOn).map((category) => {
            let cId = category._id || category.id;
            return (
              <div
                key={cId}
                onClick={() => {
                  categoryClickHandler(category.name, cId, category.isAddOn);
                  setCatAnchorEl(null);
                }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: 'pointer',
                  padding: '8px',
                  borderRadius: '8px',
                  backgroundColor: category.id === selectedCat ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                  width: '75px'
                }}
              >
                {merchantData.show_category_images && (
                  <img
                    src={category.image}
                    alt={category.name}
                    style={{
                      width: '50px',
                      height: '50px',
                      objectFit: 'cover',
                      borderRadius: '50%',
                      border: category.id === selectedCat ? '2px solid #fff' : 'none'
                    }}
                    onError={(e) => (e.target.src = "/images/blank.jpg")}
                  />
                )}
                <div style={{ marginTop: "4px", textAlign: 'center', fontSize: '16px', fontWeight: "bold" }}>
                  {category.name}
                </div>
              </div>
            );
          })}
        </div>
      </Popover>


      <Dialog open={tableDetail} fullWidth={true} maxWidth={500}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          SELECT TABLE
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon
            onClick={() => {
              cancelTable();
            }}
          />
        </IconButton>
        {tableData.length ? (
          <ul id="ul-list">
            {tableData.filter(tb => tb.isAvailable).map((tab) => (
              <li
                key={tab.number}
                onClick={() => handleTableChange(tab.number)}
                className={`table-Select ${tab.isAvailable ? "green" : "red"}`}
              >
                <TableBarIcon />
                <h3
                  style={{ display: "block", textAlign: "center" }}
                >{`Table# ${tab.number}`}</h3>
                <label>{`Capacity: ${tab.capacity}`}</label>
                <label>{`${tab.notes}`}</label>
                {tab.isServiceCall ? (
                  <b style={{ fontSize: "0.8", color: "red" }}>"CALLING"</b>
                ) : (
                  ""
                )}
              </li>
            ))}
          </ul>
        ) : (
          ""
        )}

        <div style={{ margin: "10px", textAlign: "end" }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              cancelTable();
            }}
          >
            {"Cancel"}
          </Button>
        </div>
      </Dialog>

      <Dialog
        onClose={() => setEditPriceDialog(null)}
        open={editPriceDialog ? true : false}
        maxWidth="xs"
        fullWidth={false}
      >
        <PriceUpdateDialog
          orderItems={orderItem}
          oItemIndx={editPriceDialog}
          closeDialog={setEditPriceDialog}
          updateOrder={updateOrderDetails}
        />
      </Dialog>

      <Dialog
        onClose={() => setProOpen(false)}
        open={proOpen}
        maxWidth="xs"
        fullWidth={true}
      >
        <div style={{ padding: "0px", height: "100%" }}>
          {selectPro ? (
            <div className="pro_item">
              <img
                src={
                  selectPro.image === ""
                    ? "./images/blank.jpeg"
                    : selectPro.image
                }
                onError={imageOnErrorHandler}
                style={{ width: "100%", height: "150px", borderRadius: "8px" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  fontSize: "20px",
                }}
              >
                <h5>{selectPro.name}</h5>
                <span>
                  {SelectCurrency}
                  {selectPro.price}
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              className="btn btn-danger btn-small m-2"
              onClick={() => {
                setSelectPro();
                setProOpen(false);
              }}
            >
              {"Close"}
            </button>
            <button className="btn btn-info btn-small m-2" onClick={handleItem}>
              {"Add"}
            </button>
          </div>
        </div>
      </Dialog>

      <Dialog
        onClose={() => setHoldOpen(false)}
        open={holdOpen}
        maxWidth={"lg"}
        fullWidth={true}
        style={{ zIndex: 9999 }}
      >
        <div style={{ padding: "10px", height: "100%" }}>
          <h2 style={{ margin: "10px", textAlign: "center" }}>
            {" "}
            ORDERS ON HOLD
          </h2>
          <div style={{ minWidth: "70%" }}>
            <div style={{ borderBottom: "1px solid #ccc", fontWeight: "bold", display: "flex", justifyContent: "space-between", }}>
              <div>{"Table/Customer"}</div>
              <div>{"Items Selected"}</div>
              <div>{"Actions"}</div>
            </div>
            {orderHold && orderHoldData && orderHoldData.length
              ? orderHoldData
                .filter((ordHold) => !ordHold.isDelivered && !ordHold.isPaid)
                .map((ordHold, index) => (
                  <div className="pro_item" key={index}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "16px",
                        margin: "10px 0",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Customer Name */}
                      <div >
                        {ordHold.customerName ||
                          ordHold.customerPhone || ordHold.number ||
                          index + 1}
                        <span style={{ fontSize: "0.8em" }}>{' (' + timeSince(new Date(ordHold.timestamp)) + ' ago)'}</span>
                      </div>

                      {/* Price */}
                      <div style={{ flex: 1, textAlign: "center" }}>
                        {ordHold.orderItems.map(ord => <span style={{ marginLeft: "10px" }}>{ord.name + ', '}</span>)}
                      </div>

                      {/* ❌ Cancel Button */}
                      <div style={{ marginRight: "20px" }}>
                        <Button
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => handleCancelOrd(index)}
                        >
                          X
                        </Button>
                      </div>

                      {/* Resume Button */}
                      <div>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() =>
                            resumeOrder(index)
                          }
                        >
                          {t({ id: "resume" })}
                        </Button>
                      </div>
                    </div>

                  </div>
                ))
              : "No Saved Order!"}
          </div>
        </div>
      </Dialog>
      <Dialog
        onClose={() => true}
        open={isNewOrder}
        maxWidth={"md"}
        fullWidth={true}
        style={{ zIndex: 99 }}
      >
        <StartOrderPopup
          merchantData={merchantData}
          containedIndex={containedIndex}
          handleOrderTypeTabClick={handleOrderTypeTabClick}
          handleTableDetail={handleTableDetail}
          order={order}
          setOrder={setOrder}
          setHoldOpen={setHoldOpen}
          closeDialog={() => setNewOrder(false)}
          openCustomerDialog={() => setIsCustomerPopupOpen(true)}
        />
      </Dialog>
      <Dialog
        onClose={() => setIsCustomerPopupOpen(false)}
        open={isCustomerPopupOpen}
        maxWidth={"sm"}
        fullWidth={true}
        style={{ zIndex: 99 }}
      >
        <CustomerSelectionPopup
          merchantData={merchantData}
          order={order}
          setOrder={setOrder}
          closeDialog={() => setIsCustomerPopupOpen(false)}
        />
      </Dialog>
      <Dialog
        onClose={() => setSkuErrorDialog(false)}
        open={skuErrorDialog}
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: 'error.main' }}>
          SKU Not Found
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="h4">
            SKU NOT AVAILABLE, PLEASE ADD TO CART MANUALLY
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSkuErrorDialog(false)} color="primary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={() => setWeightErrorDialog(false)}
        open={weightErrorDialog}
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: 'error.main' }}>
          Weight Reading Double Check
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="h6">
            Click refresh icon next to weight entry to re-check this item.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWeightErrorDialog(false)} color="primary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message="Order Added Successfully!"
      />
      <ToastContainer
        position="bottom-center"
        autoClose={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"

      />
      {orderProcessing && <Backdrop
        sx={{ color: '#fff', zIndex: 999999 }}
        open={orderProcessing}
        onClick={() => setOrderProcessing(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>}
    </div>
  );
};

export default Epos;
